/* Language pack: fr */
export const translationsFr = {
	resumeRecording: "Reprendre",
	chatCallMissed: "Manqué",
	chatCallDeclined: "Refusé",
	chatAudioConference: "Conférence audio",
	chatVideoConference: "Vidéoconférence",

	IDCardImages: "Images de carte d'identité",
	IT: "TI",
	Status: "Statut",
	abbreviation: "Abréviation",
	aboutUsItems: "Éléments À propos de nous",
	absent: "Absent",
	accept: "Accepter",
	actSendingDate: "Date d'envoi de l'acte",
	actionTimestamp: "Horodatage de l'action",
	actionType: "Type d'action",
	actions: "Actions",
	activateStep7_8_9: "Affectation au département des lignes de transmission d'énergie ( 7, 8, 9 )",
	activateStep8: "Affectation au département géodésique ( 8 )",
	activatedProjects: "Projets activés",
	active: "Actif",
	activeCarts: "Paniers actifs",
	activeClients: "Clients actifs",
	activeCustomers: "Clients actifs",
	activeProjectSteps: "Étapes de projet actives",
	activePromos: "Promotions actives",
	activeSales: "Ventes actives",
	activeSalesEvents: "Événements de vente actifs",
	activeServices: "services actifs",
	activeSteps: "Étapes actives",
	activeStreams: "Flux actifs",
	activeTasks: "Tâches actives",
	activeTime: "Temps actif",
	activity: "Activité",
	actualHours: "Heures réelles",
	adInterval: "Intervalle de publicité",
	adIntervalOverride: "Règles de planification",
	adIntervalOverrideDesc: "Règles de planification",
	adIntervalOverrideValue: "Règles de planification",
	adPlaylist: "Liste de lecture des annonces",
	adPlaylists: "Playlists publicitaires",
	adTracks: "Pistes publicitaires",
	add: "Ajouter",
	addAttendance: "Ajouter une présence",
	addFeature: "Ajouter une fonction",
	addFeatureLine: "Ajouter une ligne de fonction",
	addFiles: "Ajouter des fichiers",
	addMoreFiles: "Ajouter plus de fichiers",
	addNew: "Ajouter nouveau",
	addPriceLine: "Ajouter une ligne de prix",
	addRule: "Ajouter une règle",
	addToList: "Ajouter à la liste",
	addVacationInterval: "Ajouter une période de congé",
	added: "Ajouté",
	additionalDetails: "Détails supplémentaires",
	address: "Adresse",
	addressData: "Données d'adresse",
	advanceDeductions: "Retenues d'avance",
	advertisement: "Publicité",
	age: "Âge",
	ageGroups: "Groupes d'âge",
	ago: "il y a",
	agreedProjects: "Projets convenus",
	agreementAquipment: "Accord sur l'équipement",
	aiConversations: "Conversations",
	album: "Album",
	allArtists: "tous les artistes",
	allAudioTracks: "toutes les pistes audio",
	allContentItems: "tous les éléments de contenu",
	allFilesDeleted: "Tous les fichiers ont été supprimés définitivement",
	allFilesWillBeDeleted: "Tous les fichiers seront supprimés définitivement",
	allPlaylists: "toutes les playlists",
	allRegisteredContacts: "tous les clients enregistrés",
	allTickets: "Tous les tickets",
	amount: "Montant",
	analytics: "Analytique",
	answer: "Réponse",
	apartment: "Appartement",
	apply: "Appliquer",
	appsMenu: "Menu des applications",
	approved: "Approuvé",
	approvedInterval: "Intervalle approuvé",
	archive: "Archive",
	archived: "Archivé",
	areYouSure: "Êtes-vous sûr ?",
	areYouSureToDelete: "Êtes-vous sûr de vouloir supprimer ceci ?",
	artist: "Artiste",
	artistObject: "Objet artistique",
	assignedTo: "Assigné à",
	assignedToUser: "Assigné à",
	assignmentToTheConstructionDepartment: "Affectation au département de la construction",
	attach: "Joindre",
	attachFile: "Joindre un fichier",
	attachments: "Pieces jointes",
	attendance: "Présence",
	attendanceFlag: "Statut de présence",
	attendanceRequiringAttention: "Employés nécessitant une attention",
	attendanceNoAttentionItems: "Aucun employé ne nécessite d'attention",
	attendanceMissingCheckIn: "Entrée manquante",
	attendanceMissingCheckOut: "Sortie manquante",
	attendanceEarlyLeave: "Départ anticipé",
	attendanceEarlyMissings: "Départs anticipés",
	attendanceEarlyMissingHours: "Heures de départ anticipé",
	attendanceLateHours: "Heures de retard",
	attendanceShowWorkedHours: "Afficher les heures travaillées",
	attendanceUnapprovedAbsence: "Absence non justifiée",
	attendanceDeptAttendance: "Présence par département",
	attendanceDeviceHealth: "État des appareils et synchronisation en direct",
	attendanceLastSync: "Dernière synchronisation",
	attendanceLiveFeed: "Flux de présence en direct",
	attendanceNoRecentPunches: "Aucun pointage récent",
	attendanceManualEntryTag: "Manuel",
	attendanceUnmappedPunch: "Non associé",
	attendancePendingItems: "en attente",
	flexCardTotal: "Cartes Flex",
	attendanceCards: "Cartes de présence",
	flexCardTotalSubtitle: "Identifiants Flex attribués ou ignorés",
	flexCardsAttached: "Associé",
	flexCardsAttachedSubtitle: "Identifiants uniques associés à des utilisateurs",
	flexCardsIgnored: "Ignoré",
	flexCardsIgnoredSubtitle: "Ignoré dans les paramètres RH",
	flexCardsDuplicateAttached: "Associé en double",
	flexCardIds: "identifiants de carte",
	noDuplicateFlexCards: "Aucun doublon",
	attendanceTrendPctOfEmployeesPresent: "% d'employés présents",
	yesterday: "Hier",
	attendanceFilterThisWeek: "Cette semaine",
	attendanceFilterThisMonth: "Ce mois-ci",
	attendanceFilterCustom: "Personnalisé",
	attendanceSelectRange: "Sélectionner une plage",
	attendanceCustomRangeCapped: "La plage personnalisée est limitée à 90 jours",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "Présence d'aujourd'hui",
	attendanceTitleYesterday: "Présence d'hier",
	attendanceTitleThisWeek: "Présence de cette semaine",
	attendanceTitleThisMonth: "Présence de ce mois",
	attendanceTitleCustom: "Présence de la période sélectionnée",
	attendanceTitleTodayKpis: "KPI de présence d'aujourd'hui",
	attendanceTitleYesterdayKpis: "KPI de présence d'hier",
	attendanceTitleThisWeekKpis: "KPI de présence de cette semaine",
	attendanceTitleThisMonthKpis: "KPI de présence de ce mois",
	attendanceTitleCustomKpis: "KPI de la période sélectionnée",
	attendanceTrendDays: "Tendance de présence — {n} derniers jours",
	attendanceNotAttendedYet: "Pas encore arrivé",
	attendanceUpcomingAbsences: "Absences à venir",
	attendanceUpcomingAbsencesEmpty: "Aucune absence à venir",
	attendanceUpcomingAbsencesTomorrow: "Demain",
	attendanceUpcomingAbsencesInDays: "Dans {days} jours",
	attendanceExceptions: "Exceptions de présence",
	attendanceExceptionsMissingCheckIn: "Entrées manquantes",
	attendanceExceptionsMissingCheckOut: "Sorties manquantes",
	attendanceExceptionsEarlyLeaves: "Départs anticipés",
	attendanceExceptionsUnapprovedAbsences: "Absences non justifiées",
	attendanceExceptionsDuplicatePunches: "Pointages en double",
	attendanceMonthlyKpis: "Indicateurs mensuels de présence",
	attendanceKpiRate: "Taux de présence",
	attendanceKpiAvgArrival: "Heure d'arrivée moyenne",
	attendanceKpiLateArrivals: "Retards",
	attendanceKpiAbsentDays: "Jours d'absence",
	attendanceKpiOvertimeHours: "Heures supplémentaires",
	attendanceLeaveBalanceOverview: "Aperçu du solde de congés",
	attendanceLeaveBalanceVacationRemaining: "Solde de congés restant",
	attendanceLeaveBalanceSickUsed: "Congés maladie utilisés",
	attendanceLeaveBalanceBusinessTrips: "Voyages d'affaires",
	attendanceLeaveBalancePendingRequests: "Demandes en attente",
	attendanceLeaveBalanceCoverage: "{covered} sur {total} employés",
	attendanceTopInsights: "Principales analyses de présence",
	attendanceInsightNoData: "Aucune analyse disponible pour le moment",
	attendanceInsightHighestLateness: "{dept} a le taux de retard le plus élevé cette semaine ({delta})",
	attendanceInsightFullAttendanceToday: "{dept} a 100 % de présence",
	attendanceInsightTrendImproved: "La présence s'est améliorée de {pct} % par rapport à la période précédente",
	attendanceInsightTrendDeclined: "La présence a diminué de {pct} % par rapport à la période précédente",
	attendanceInsightApproachingOvertime: "{count} employés approchent de leur limite d'heures supplémentaires",
	attendancePreviousWeek: "Semaine dernière",
	attendanceCurrentWeek: "Cette semaine",
	attendanceAddInterval: "Ajouter un intervalle",
	attendanceBreakLabel: "Pause",
	attendanceCorrectionMode: "Mode correction",
	attendanceCustomIntervals: "Intervalles personnalisés",
	attendanceDashboard: "Tableau de bord de présence",
	attendanceReports: "Rapports",
	attendanceCalendarTab: "Calendrier",
	reports: "Rapports",
	shiftCoverage: "Couverture des quarts",
	previousPeriod: "Période précédente",
	nextPeriod: "Période suivante",
	failedToSave: "Impossible d'enregistrer le commentaire d'heures supplémentaires",
	expandForDailyDetail: "Développer la ligne pour le détail quotidien",
	noDataForPeriod: "Aucune donnée pour cette période",
	attendanceHistory: "Historique de présence",
	attendanceDayOffTab: "Jour de congé",
	attendanceDayType: "Type de jour",
	attendanceDetectedIntervals: "Intervalles détectés",
	attendanceEditDay: "Modifier le jour",
	attendanceHrsTotal: "h au total",
	attendanceViewWeek: "Semaine",
	attendanceViewMonth: "Mois",
	attendanceViewDay: "Jour",
	day: "Jour",
	attendanceOpenFrom: "Ouvert depuis {time}",
	attendanceFromStillActive: "Depuis {time} → toujours actif",
	attendanceTotalWorked: "Total travaillé",
	attendanceMissingUncovered: "Manquant / non couvert",
	attendanceNoData: "Aucune donnée",
	attendanceNoDataForDay: "Aucune donnée de présence pour ce jour.",
	attendanceIntervalApprovedOk: "Approuvé / OK",
	attendanceIntervalEachRowInvalid:
		"Indiquez une heure de début et de fin valides pour chaque intervalle",
	attendanceIntervalTimesInvalid: "Indiquez une heure de début et de fin valides",
	attendanceIntervalsMode: "Intervalles",
	attendanceIntervalsReviewHint:
		"Vérifiez les périodes travaillées, les congés et les manques. Ajoutez ci-dessous des intervalles de correction manuelle pour les marquer comme approuvés, travail, télétravail, congé maladie, congé payé, non payé ou autre.",
	attendanceLogSubtitle: "Saisie manuelle de présence — travail, arrêts maladie, congés",
	attendanceLogTitle: "Journal de présence",
	attendanceManualResolutionIntervals: "Intervalles de correction manuelle",
	attendanceMissingLabel: "Manquant",
	attendanceNoManualIntervalsYet: "Aucun intervalle manuel ajouté",
	attendanceNoUncovered: "Aucun intervalle non couvert détecté",
	attendanceOptionalNotePlaceholder: "Note facultative…",
	attendancePtoLeaveSection: "Congé payé / absence",
	attendanceReport: "Rapport de présence",
	attendanceResolveInterval: "Résoudre cet intervalle",
	attendanceResyncTooltip: "Resynchroniser la présence de cet employé",
	attendanceResyncSuccess: "Resynchronisation de la présence démarrée",
	attendanceResyncFailed: "Échec de la resynchronisation de la présence",
	attendanceSavedSuccess: "Présence enregistrée avec succès",
	attendanceStatusUpcoming: "À venir",
	attendanceSelectEmployeePrompt: "Sélectionnez un employé pour voir la présence",
	attendanceTrend: "Tendance de présence",
	attendanceTrendPctPresent: "% Présents",
	attendanceUncoveredMissing: "Non couvert / manquant",
	attendanceUnsavedChanges: "Modifications non enregistrées",
	attendanceWholeDayStatus: "Statut pour la journée entière",
	shiftWorker: "Travailleur posté",
	attendanceIgnoreMode: "Ignorer",
	attendanceIgnoreScopeWeekdays: "Jours de la semaine",
	attendanceIgnoreScopeDateRange: "Plage de dates",
	attendanceIgnoreScopeWeekdaysHint: "S'applique uniquement aux jours de la semaine sélectionnés dans cette période.",
	attendanceIgnoreScopeDateRangeHint: "S'applique à chaque jour de cette période.",
	attendanceIgnoreAppliesTo: "S'applique à",
	attendanceIgnoreLateArrival: "Retard à l'arrivée",
	attendanceIgnoreEarlyLeave: "Départ anticipé",
	attendanceIgnoreWindowStart: "Début de la fenêtre d'ignorance",
	attendanceIgnoreWindowEnd: "Fin de la fenêtre d'ignorance",
	attendanceIgnoreRulesList: "Règles d'ignorance",
	attendanceIgnoreRulesEmpty: "Aucune règle d'ignorance pour l'instant",
	attendanceIgnoreDaysOfWeekRequired: "Sélectionnez au moins un jour",
	attendanceIgnoredLabel: "Ignoré",
	attendanceNoCardLabel: "Aucune carte",
	attendanceWork: "Travail",
	attendanceWorked: "Travaillé",
	attendanceWorkedIntervals: "Intervalles travaillés",
	attendanceMissingIntervals: "Intervalles manquants",
	attendanceStillInOffice: "Toujours au bureau",
	attendanceAddEvent: "Ajouter un événement",
	attendanceAddAttendanceEvent: "Ajouter un événement de présence",
	attendanceDeleteEventTitle: "Supprimer l'événement de présence ?",
	attendanceDeleteEventText:
		"Cela supprime uniquement cet événement d'entrée/sortie ajouté manuellement.",
	attendanceNoMissingIntervals: "Aucun intervalle manquant pour ce jour",
	attendanceOfficeSince: "Depuis {time}",
	attendanceLastOutAt: "Dernière sortie {time}",
	attendanceEventSingular: "événement",
	attendanceEventPlural: "événements",
	attendancePunchIn: "Entrée",
	attendancePunchOut: "Sortie",
	solveThis: "Résoudre",
	editSolvedStatus: "Modifier le statut résolu",
	officeStatus: "Statut au bureau",
	outOfOffice: "Hors du bureau",
	noPunches: "Aucun pointage",
	lastActionWasCheckIn: "Dernière action : entrée",
	lastActionWasCheckOut: "Dernière action : sortie",
	noCheckInYet: "Pas encore d'entrée",
	manual: "Manuel",
	resolved: "Résolu",
	attendanceManualStatusApplyTicketTimeTo: "Appliquer le temps du ticket à",
	attendanceManualStatusColumnAttendanceType: "Type de présence",
	attendanceManualStatusColumnTimeAction: "Action sur le temps",
	attendanceManualStatusMapsToType: "Correspond au type de présence",
	attendanceManualStatusTicketTimeAction: "Action temporelle d'automatisation du ticket",
	attendanceTicketTimePhraseAdd: "Ajouter du temps de {type}",
	attendanceTicketTimePhraseSubtract: "Soustraire du temps de {type}",
	attendanceTimeOpAdd: "Ajouter le temps du ticket",
	attendanceTimeOpNone: "Aucun changement du solde de temps",
	attendanceTimeOpSubtract: "Soustraire le temps du ticket",
	attendanceTypeOptionAbsent: "Absent",
	attendanceTypeOptionBusinessTrip: "Voyage d'affaires",
	attendanceTypeOptionHolidayNonWorking: "Jour férié / non travaillé",
	attendanceTypeOptionJustifiedAbsence: "Absence justifiée (excusée)",
	attendanceTypeOptionMaternity: "Congé maternité",
	attendanceTypeOptionPaidVacation: "Congé payé",
	attendanceTypeOptionRemote: "Télétravail",
	attendanceTypeOptionSickLeave: "Congé maladie",
	attendanceTypeOptionUnjustifiedAbsence: "Absence injustifiée (non excusée)",
	attendanceTypeOptionUnpaidLeave: "Congé sans solde",
	attendanceTypeOptionWork: "Travail",
	audio: "Audio",
	autoDeletion: "Suppression automatique",
	averageDailyHours: "Heures moyennes par jour",
	avgDaily: "Moyenne quotidienne",
	avgDailyHours: "Heures quotidiennes moyennes",
	avgHoursPerWorkingDay: "Heures moyennes par jour ouvrable",
	avgOrderValue: "Valeur moyenne de commande",
	avgResolutionTime: "Temps de résolution moyen",
	avgResponseTime: "Temps de réponse moyen",
	avgTracksPerPlaylist: "Moyenne pistes/playlist",
	back: "Retour",
	bank: "Banque",
	bankAccount: "Compte bancaire",
	bankCart: "Carte bancaire",
	bankEmitet: "Banque",
	banner: "Bannière",
	baseSalary: "Salaire de base",
	baseSalaryHourlyLinked:
		"Met à jour le taux horaire à partir du brut ÷ heures normales (si heures > 0).",
	basicInformation: "Informations de base",
	beginningOfAcquaintance: "Début de la connaissance",
	beginningOfContract: "Début du contrat",
	beginningOfTraining: "Début de la formation",
	benefits: "Avantages",
	bestSeller: "Meilleure vente",
	bestSellers: "Meilleures ventes",
	bestSellingItemsByRevenue: "Articles les plus vendus par revenu",
	bitrate: "Débit binaire",
	biweekly: "Bimensuel",
	blogItems: "Éléments de blog",
	blogs: "Blogs",
	bonuses: "Primes",
	bpm: "BPM",
	branch: "Branche du réseau électrique",
	branches: "Liste des branches",
	branchesCitiesVillages: "Branches, Villes, Villages",
	brand: "Marque",
	brands: "Marques",
	building: "Bâtiment",
	businessTrip: "Déplacement professionnel",
	buttonText: "Texte du bouton",
	bypassSteps: "Passer les étapes",
	calAddCalendarTooltip: "Créer un calendrier et le partager",
	calAddEvent: "Ajouter un événement",
	calAddReminder: "Ajouter un rappel",
	calAlarm15m: "15 min avant",
	calAlarm1d: "1 jour avant",
	calAlarm1h: "1 h avant",
	calAlarm1w: "1 semaine avant",
	calAlarm2d: "2 jours avant",
	calAlarm2h: "2 h avant",
	calAlarm30m: "30 min avant",
	calAlarm5m: "5 min avant",
	calAlarmAtEvent: "À l’heure de l’événement",
	calAllDay: "Toute la journée",
	calApiNotConfigured: "L’API calendrier n’est pas configurée.",
	calCalendarColorLabel: "Couleur du calendrier",
	calCalendarCreateFailed: "Impossible de créer le calendrier",
	calCalendarCreated: "Calendrier créé",
	calCalendarDeleted: "Calendrier supprimé",
	calCalendarNameLabel: "Nom du calendrier",
	calCalendarNamePh: "ex. Planning équipe",
	calCalendarNameRequired: "Saisissez un nom de calendrier",
	calCalendarSelect: "Calendrier",
	calCalendarUpdateFailed: "Impossible de mettre à jour le calendrier",
	calCalendarUpdated: "Calendrier mis à jour",
	calCalendarsLabel: "Calendriers :",
	calGoogleCalendarLabel: "Google Agenda :",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "Réunions :",
	calCancel: "Annuler",
	calCheckAll: "Tout cocher",
	calColor: "Couleur",
	calCreateCalendar: "Créer un calendrier",
	calDay: "Jour",
	calDayOverviewTitle: "Jour",
	calDefaultCalendarName: "Calendrier",
	calDelete: "Supprimer",
	calDeleteCalendarHasEvents:
		"Ce calendrier contient {count} événement(s). Que voulez-vous en faire ?",
	calDeleteCalendarNoEvents: "Cette action est irréversible.",
	calDeleteCalendarOnly: "Supprimer uniquement le calendrier",
	calDeleteCalendarTitle: "Supprimer le calendrier ?",
	calDeleteCalendarWithEvents: "Supprimer avec les événements",
	calDeleteEventText: "Action irréversible.",
	calDeleteEventTitle: "Supprimer l’événement ?",
	calDeleteFailed: "Échec de la suppression",
	calDescription: "Description",
	calDescriptionPh: "Description (facultatif)",
	calEditCalendarTitle: "Modifier le calendrier",
	calEditCalendarTooltip: "Modifier le calendrier",
	calEditEvent: "Modifier l’événement",
	calEditTooltip: "Modifier",
	calEnd: "Fin",
	calEndBeforeStart: "La fin ne peut précéder le début",
	calEndTime: "Heure de fin",
	calEvent: "Événement",
	calEventCreated: "Événement créé",
	calEventDeleted: "Événement supprimé",
	calEventTitle: "Titre",
	calEventTitlePh: "Titre de l’événement",
	calEventUpdated: "Événement mis à jour",
	calEventsPlural: "événements",
	calExportIcs: "Exporter .ics",
	calFailedLoadEvents: "Échec du chargement des événements",
	calHrBirthdayEvent: "Anniversaire",
	calHrBirthdays: "Anniversaires",
	calHrContractEnd: "Fin de contrat",
	calHrContractEndEvent: "Fin de contrat",
	calHrContractStart: "Début de contrat",
	calHrContractStartEvent: "Début de contrat",
	calHrIdEvent: "Expiration ID",
	calHrIdExpiry: "Expiration pièce d’identité",
	calHrPassportEvent: "Expiration passeport",
	calHrPassportExpiry: "Expiration passeport",
	calHrPositionReview: "Révision de poste",
	calHrPositionReviewEvent: "Révision de poste",
	calHrSalaryReview: "Révision salaire",
	calHrSalaryReviewEvent: "Révision salaire",
	calImportButton: "Importer",
	calImportEventsTitle: "Importer des événements",
	calImportFoundInFile: "trouvé(s) dans le fichier. Choisissez un calendrier :",
	calImportIcs: "Importer .ics",
	calImportedEventTitle: "Événement importé",
	calItLabel: "IT :",
	calItWarrantyEnd: "Fin de garantie",
	calItWarrantyEndEvent: "Fin de garantie",
	calMonth: "Mois",
	calNewCalendarTitle: "Nouveau calendrier",
	calNewEvent: "Nouvel événement",
	calNoCalendar: "Aucun calendrier",
	calNoCalendarUncategorised: "Aucun calendrier (sans catégorie)",
	calNoEventsInIcs: "Aucun événement dans le fichier .ics",
	calNoEventsThisDay: "Aucun événement ce jour-là.",
	calNoRemindersThisDay: "Aucun rappel ce jour-là.",
	calDayWeatherMap: "Carte météo",
	calDayHourlyForecast: "Prévisions horaires",
	calDayWeatherUnavailable: "Prévision indisponible pour cette date",
	calDayEventsSection: "Événements",
	calDayRemindersSection: "Rappels",
	calOpenProfile: "Ouvrir le profil",
	calPeopleLabel: "Personnes :",
	calReminders: "Rappels",
	calRemindersLabel: "Rappels :",
	calAttendanceLabel: "Présences :",
	calSecurityLabel: "Sécurité :",
	calSecurityAlerts: "Alertes",
	calSecuritySessions: "Sessions",
	calSecurityTokenExpiry: "Expiration du jeton",
	calRemindersToggle: "Rappels actifs",
	calSave: "Enregistrer",
	calSaveFailed: "Échec de l’enregistrement",
	calShareWithUsers: "Partager avec des utilisateurs",
	calShareWithUsersPh: "Rechercher et sélectionner",
	calStart: "Début",
	calStartEndRequired: "Heure de début et de fin requises",
	calStartTime: "Heure de début",
	calSwalDelete: "Supprimer",
	calTaskHigh: "Élevé",
	calTaskLow: "Faible",
	calTaskMedium: "Moyen",
	calTaskUrgent: "Urgent",
	calTasksLabel: "Tâches :",
	calTicketsLabel: "Tickets :",
	calToday: "Aujourd’hui",
	calUserFallback: "Utilisateur",
	calWeek: "Semaine",
	calculatePayroll: "Calculer la paie",
	calculated: "Calculé",
	calculations: "Calculs",
	calendarEventType: "Événement du calendrier",
	calling: "Appel",
	cancel: "Annuler",
	clearText: "Effacer le texte",
	cancelAction: "Annuler l'action",
	cancelBack: "Annuler retour",
	cancelled: "Annulé",
	cannotBeUndone: "Cette action est irréversible.",
	cannotPayOnline: "Impossible de payer en ligne",
	cart: "Employés",
	categories: "Catégories",
	category: "Catégorie",
	categoryPerformance: "Performance des catégories",
	certificate: "Certificat",
	certificateImages: "Images de certificat",
	certificates: "Certificats",
	changedDate: "Date de modification",
	channel: "Canal",
	channelWritePermissionDescription:
		"Seuls les administrateurs du chat peuvent ecrire des messages",
	channels: "Canaux",
	charts: "Graphiques",
	chatActions: "actions du chat",
	chatActiveLabel: "actif...",
	chatAddOption: "Ajouter une option",
	chatAddUsers: "Ajouter des utilisateurs",
	chatAddedToGroupNotification: "Ajoute au chat de groupe",
	chatAddedYouToGroup: "vous a ajoute a",
	chatAudioCall: "appel audio",
	chatBulkDeleteFailed: "La suppression en masse a echoue.",
	chatBulkForwardFailed: "Le transfert en masse a echoue.",
	chatCallMessage: "Message d'appel",
	chatChoosingEmoji: "choisissent un emoji...",
	chatClickMapToChoosePoint: "Cliquez sur la carte pour choisir un point personnalise.",
	chatCoordinatesUnavailable: "Coordonnees indisponibles",
	chatCopyCoordinates: "Copier les coordonnees",
	chatCopyCoordinatesFailed: "Echec de la copie des coordonnees.",
	chatCreatePoll: "Creer un sondage",
	chatCurrent: "Actuel",
	chatCurrentLocation: "Position actuelle",
	chatDashboard: "Tableau de bord de chat",
	chatDeleteFailed: "Echec de suppression",
	chatDeleteForMeOnly: "Supprimer pour moi uniquement",
	chatDeleteForParticipants: "Supprimer aussi pour les participants",
	chatDeleteLocation: "Supprimer la localisation",
	chatDeleteSelectedMessagesDescription:
		"Cette action supprime les messages selectionnes de votre vue de chat. Les messages qui ne peuvent pas etre supprimes avec vos permissions actuelles seront marques en echec.",
	chatDeleteSelectedMessagesTitle: "Supprimer les messages selectionnes",
	chatDeletionPartialWarning:
		"Les resultats de suppression peuvent etre partiels si certains messages sont deja supprimes ou si les verifications de permission echouent.",
	chatDepartmentSaveFailed: "Echec de la mise a jour du service",
	chatDepartmentSaveFailedTryAgain: "Veuillez essayer de mettre a jour le service a nouveau.",
	chatDeselectAllMessages: "Tout deselectionner",
	chatDestinationChatsLabel: "Chats de destination",
	chatDestinationChatsPlaceholder: "Selectionnez un ou plusieurs chats",
	chatDirect: "Discussion directe",
	chatDirectChat: "Chat direct",
	chatEditFailed: "Impossible de modifier le message",
	chatEditFailedTryAgain: "Veuillez reessayer de modifier.",
	chatEditMessagePlaceholder: "Modifier le message...",
	writeMessage: "Écrivez un message...",
	chatEditingMessage: "Modification du message",
	chatExitSelectionMode: "Quitter le mode de selection",
	chatExpired: "Expire",
	chatForwardFailed: "Echec du transfert",
	chatForwardSelectedMessagesTitle: "Transferer les messages selectionnes",
	chatForwardableLabel: "transferables",
	chatGeolocationUnavailable: "La geolocalisation n'est pas disponible dans ce navigateur.",
	chatGroupChat: "chat de groupe",
	chatGroupInfo: "Infos du groupe",
	chatGroupMembers: "Membres du groupe",
	chatGroupSettings: "Parametres du groupe",
	chatGroupSettingsDescription: "Definissez l'image du groupe et le service RH lie",
	chatID: "ID de chat",
	chatImageUploadFailed: "Echec du telechargement de l'image",
	chatImageUploadFailedTryAgain: "Veuillez essayer de telecharger une autre image.",
	chatIncludeLabel: "Inclure",
	chatIsChoosingEmoji: "choisit un emoji...",
	chatIsTyping: "est en train d'ecrire...",
	chatLastUpdated: "Derniere mise a jour",
	chatLatitude: "Latitude",
	chatLive: "En direct",
	chatLiveFor: "En direct pendant",
	chatLiveLocation: "Position en direct",
	chatLiveLocationOptInWarning:
		"La localisation en direct est optionnelle et peut etre arretee a tout moment.",
	chatLiveLocationSharingActive: "Le partage de localisation en direct est actif",
	chatLoadingLocation: "Chargement de la localisation...",
	chatLoadingPoll: "Chargement du sondage...",
	chatLongitude: "Longitude",
	chatMessagesCannotBeForwarded: "message(s) ne peuvent pas etre transferes et seront ignores.",
	chatMessagesDeleted: "Messages supprimes",
	chatMessagesForwarded: "Messages transferes",
	chatMoreActions: "Plus d'actions",
	chatNoAvailableUsersToAdd: "Tous les utilisateurs disponibles sont deja dans ce groupe.",
	chatNoBackground: "Sans fond",
	chatNoChatsFound: "Aucun chat trouve",
	chatNoMessagesForwarded: "Aucun message n'a pu etre transfere.",
	chatNoSelectedMessagesDeleted: "Aucun message selectionne n'a pu etre supprime.",
	chatOpenDepartmentPage: "Ouvrir la page du service",
	chatOpenMap: "Ouvrir la carte",
	chatOptionalAddressLabel: "Etiquette d'adresse facultative",
	chatOwnMessagesLabel: "personnels",
	chatPartialDelete: "Suppression partielle",
	chatPartialForward: "Transfert partiel",
	chatPattern: "Motif",
	chatPickOnMap: "Choisir sur la carte",
	chatPickPointOnMap: "Choisissez un point sur la carte.",
	chatPinnedLocation: "Emplacement epingle",
	chatPollAddAnotherOption: "Ajouter une autre option",
	chatPollAddOptionFailed: "Impossible d'ajouter l'option.",
	chatPollAllowAddingOptions: "Autoriser l'ajout d'options",
	chatPollAllowMultipleAnswers: "Autoriser plusieurs reponses",
	chatPollAllowRevote: "Autoriser le revote",
	chatPollAnonymous: "Sondage anonyme",
	chatPollAnonymousCannotAddOptions: "Un quiz anonyme ne peut pas autoriser l'ajout d'options.",
	chatPollAtLeastOptions: "Nombre minimum d'options :",
	chatPollAutoClose: "Fermeture automatique",
	chatPollChangeVote: "Modifier le vote",
	chatPollChooseCorrectAnswer: "Choisissez au moins une bonne reponse pour le quiz.",
	chatPollCloseDate: "Date de fermeture",
	chatPollCloseDateOrOpenPeriod:
		"Utilisez soit une date de fermeture soit une periode d'ouverture, pas les deux.",
	chatPollCloseFailed: "Impossible de fermer le sondage.",
	chatPollClosePoll: "Fermer le sondage",
	chatPollCorrectAnswer: "Bonne reponse",
	chatPollCorrectAnswers: "Bonnes reponses",
	chatPollCreateFailed: "Impossible de creer le sondage.",
	chatPollDeletePoll: "Supprimer le sondage",
	chatPollDescriptionMax: "La description doit contenir au maximum",
	chatPollExplanationMax: "L'explication doit contenir au maximum",
	chatPollHideResultsUntilClosed: "Masquer les resultats jusqu'a la fermeture",
	chatPollIncorrectAnswer: "Reponse incorrecte",
	chatPollLeaveEmptyKeepOpen: "Laisser vide pour garder le sondage ouvert",
	chatPollLeaveEmptyNoTimer: "Laisser vide pour aucun minuteur",
	chatPollLoadVotersFailed: "Impossible de charger les votants.",
	chatPollMultipleChoice: "Choix multiple",
	chatPollNewOption: "Nouvelle option",
	chatPollNoVoteYet: "Pas encore de vote",
	chatPollNoVotersForOption: "Aucun votant trouve pour cette option.",
	chatPollOpenPeriod: "Periode d'ouverture",
	chatPollOptionMax: "L'option doit contenir au maximum",
	chatPollOptionRequired: "L'option est requise.",
	chatPollOptionsUnique: "Les options doivent etre uniques.",
	chatPollPublic: "Public",
	chatPollQuestionMax: "La question doit contenir au maximum",
	chatPollQuestionRequired: "La question est requise.",
	chatPollQuiz: "Quiz",
	chatPollQuizExplanation: "Explication du quiz",
	chatPollRegular: "Standard",
	chatPollResultsHiddenUntilClosed: "Les resultats sont masques jusqu'a la fermeture du sondage.",
	chatPollSearchVoters: "Rechercher des votants",
	chatPollShuffleOptions: "Melanger les options",
	chatPollSingleChoice: "Choix unique",
	chatPollSingleChoiceOneCorrect:
		"Un quiz a choix unique ne peut avoir qu'une seule bonne reponse.",
	chatPollSubmitVoteFailed: "Impossible d'envoyer votre vote.",
	chatPollViewVoters: "Voir les votants",
	chatPollVoteRecorded: "Vote enregistre",
	chatPollVotersLabel: "votants",
	chatPollVotersTitle: "Votants du sondage",
	chatPollYouVoted: "Vous avez vote.",
	chatPollYouVotedCanChange: "Vous avez vote et pouvez modifier votre reponse.",
	chatPreviewChronological: "Apercu (chronologique)",
	chatProvider: "Fournisseur",
	chatReadCurrentLocationFailed: "Impossible de lire votre position actuelle.",
	chatRefreshCurrentLocation: "Actualiser la position actuelle",
	chatRuleAllow: "Oui",
	chatRuleDeny: "Non",
	chatRuleTimed: "Oui, mais seulement pour un temps limite",
	chatRuleTimerDescription:
		"Exemple : mettez 1 pour autoriser l'action seulement pendant la premiere minute apres l'envoi.",
	chatRuleTimerMinutes: "Minuteur en minutes",
	chatSearchMessage: "Rechercher un message",
	chatSelectAllMessages: "Tout selectionner",
	chatSelectDepartment: "Selectionnez le service RH",
	chatSelectOrLoadLocationFirst: "Selectionnez ou chargez d'abord un emplacement.",
	chatSelectRepeatingBackground: "Selectionnez un fond repetitif",
	chatSelectUsersToAdd: "Selectionnez les utilisateurs a ajouter",
	chatSelectedLabel: "selectionnes",
	chatSelectionMode: "Mode de selection",
	chatSendCurrentLocation: "Envoyer la position actuelle",
	chatSendLocationFailed: "Echec de l'envoi de la localisation.",
	chatSendPinnedLocation: "Envoyer l'emplacement epingle",
	chatSendVenue: "Envoyer le lieu",
	chatSentAt: "Envoye",
	chatSettings: "Parametres du chat",
	chatSettingsEditRule: "Modifier les messages",
	chatSettingsEditRuleDescription:
		"Choisissez si les messages envoyes peuvent etre modifies toujours, jamais, ou seulement pendant un temps limite.",
	chatSettingsForwardRule: "Transferer les messages",
	chatSettingsForwardRuleDescription:
		"Autorisez le transfert toujours, jamais, ou seulement pendant un temps limite apres l'envoi du message.",
	chatSettingsGlobalPageSubtitle:
		"Definissez ici une fois les regles des chats personnels. Seuls les administrateurs du groupe peuvent regler ses regles.",
	chatSettingsGlobalPageTitle: "Parametres globaux du chat",
	chatSettingsGlobalRulesDescription:
		"Ces regles s'appliquent a tous les chats personnels.",
	chatSettingsGlobalSavedSuccess: "Les parametres globaux du chat ont ete mis a jour",
	chatSettingsCompactMode: "Mode compact",
	chatSettingsCompactModeDescription:
		"Reduisez les espacements et la taille des avatars pour afficher plus de chats dans la barre laterale.",
	chatSettingsSidebarDescription: "Controlez l'affichage des chats dans la barre laterale gauche.",
	chatSettingsSidebarTitle: "Barre laterale du chat",
	chatSettingsShowLastMessage: "Afficher le dernier message",
	chatSettingsShowLastMessageDescription:
		"Afficher un apercu du dernier message ainsi que sa date ou son heure dans la barre laterale.",
	chatSettingsReplyRule: "Repondre aux messages",
	chatSettingsReplyRuleDescription:
		"Controlez si les membres peuvent repondre toujours, jamais, ou seulement pendant une fenetre de temps apres l'envoi.",
	chatSettingsResetToGlobal: "Retablir les regles par defaut du groupe",
	chatSettingsRulesAdminOnly: "Seuls les administrateurs du chat peuvent modifier ces regles.",
	chatSettingsRulesDescription:
		"Definissez si les membres peuvent transferer, repondre ou modifier les messages, avec une limite de temps si besoin.",
	chatSettingsRulesTitle: "Regles du chat",
	chatSettingsSaveFailed: "Impossible d'enregistrer les parametres du chat",
	chatSettingsSaveFailedTryAgain: "Veuillez reessayer.",
	chatSettingsUsingCustomRules:
		"Ce groupe utilise les regles definies par ses administrateurs.",
	chatSettingsUsingGlobalRules: "Ce groupe utilise les regles par defaut.",
	chatShareLocation: "Partager la localisation",
	chatSkipLabel: "Ignorer",
	chatSkippedLabel: "ignores",
	chatStartCall: "Demarrer l'appel",
	chatStartLiveSharing: "Demarrer le partage en direct",
	chatStopLiveSharing: "Arreter le partage en direct",
	chatType: "Type de chat",
	chatTypeToSearch: "Tapez pour rechercher",
	chatTyping: "ecrivent...",
	chatUnnamedChat: "Chat sans nom",
	chatUpdatingSharedLocationFor: "Mise a jour de cette position partagee pendant",
	chatUploadGroupImage: "Telecharger l'image du groupe",
	chatUserInfo: "Infos utilisateur",
	chatUsersSaveFailed: "Echec de l'ajout des utilisateurs",
	chatUsersSaveFailedTryAgain: "Veuillez reessayer d'ajouter les utilisateurs selectionnes.",
	chatVenue: "Lieu",
	chatVenueTitle: "Titre du lieu",
	chatVideoCall: "appel video",
	chatViewReportedMessages: "Voir les messages signales",
	chatWaitingDeviceCoordinates: "En attente des coordonnees de l'appareil...",
	childcarePayment: "Paiement garde d'enfants",
	chooseBoard: "Sélectionnez Board pour voir ses catégories et ses tâches",
	cities: "Villes",
	city: "Ville",
	clear: "Effacer",
	clearFilters: "Effacer les filtres",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"Cliquez sur le bouton ci-dessous pour faire le prochain pas dans votre parcours",
	contact: "Contact",
	contactEngagement: "Engagement des clients",
	contactGroup: "Groupe de clients",
	contactGroups: "Groupes de clients",
	contactPlaylist: "Liste de lecture du client",
	contactProfile: "Profil client",
	contacts: "contacts",
	contactsByGender: "Clients par sexe",
	contactsByGroup: "Clients par groupe",
	contactsUsing: "clients utilisant",
	contactsWithCarts: "Clients avec paniers",
	contactsWithFavorites: "Clients avec favoris",
	clockInOut: "Arrivée / Départ",
	close: "Fermer",
	closeNavigation: "Fermer la navigation",
	closeTicket: "Fermer le ticket",
	closed: "Fermé",
	closed_late: "Fermé après la date d'échéance",
	closedDate: "Date de fermeture",
	closedTickets: "Billets fermés",
	cmDashboard: "Tableau de bord CM",
	code: "Code",
	coin: "Pièce",
	coinBurnTime: "Temps de combustion de la pièce",
	coinCount: "Nombre de pièces",
	color: "Couleur",
	comment: "Commentaire",
	commentTicket: "Commentaire de ticket",
	commissions: "Commissions",
	communicationPreferences: "Préférences de communication",
	community: "Communauté",
	company: "Société",
	completed: "Terminé",
	completedDate: "Date de fin",
	completedTasks: "Tâches terminées",
	completionRate: "taux d'achèvement",
	confirm: "Confirmer",
	confirmAction: "Confirmer l'action",
	contactForm: "Formulaire de contact",
	contactForms: "Formulaires de contact",
	contactType: "Type de contact",
	contacts: "Contacts",
	contentByType: "Contenu par type",
	contentItems: "Éléments de contenu",
	contentManagementOverview: "Aperçu du système de gestion de contenu",
	contentOverTime: "Contenu créé au fil du temps (30 derniers jours)",
	continue: "Continuer",
	contract: "Contrat",
	contractEndDate: "Date de fin du contrat",
	contractStartDate: "Date de début du contrat",
	contractor: "Entrepreneur",
	copy: "Copier",
	costOfBuildingPart: "Coût de la partie construction",
	costOfBuildingPermit: "Coût du permis de construire",
	country: "Pays",
	cpu: "Processeur",
	create: "Commande",
	createBoard: "Créer un nouveau tableau",
	createChat: "Créer un chat",
	createGroupChat: "Créer un chat de groupe",
	createGroupSubmit: "Créer",
	addNewCategory: "Ajouter une nouvelle catégorie",
	createNewCategory: "Créer une nouvelle catégorie",
	created: "Créé",
	createdAt: "Créé le",
	createdBy: "Créé par",
	createdByUser: "Créé par l'utilisateur",
	critical: "Critique",
	crmDashboard: "Tableau de bord CRM",
	cta1: "Appel à l'action section 1",
	cta2: "Appel à l'action section 2",
	cta3: "Appel à l'action section 3",
	currency: "Devise",
	currentlyStreaming: "actuellement en diffusion",
	currentlyWorking: "Au travail",
	custom: "Personnalisé",
	customerAcquisition: "Acquisition de clients",
	customerBaseOverview: "Aperçu de la base de clients",
	customerInsights: "Aperçus clients",
	customerRelationshipOverview: "Aperçu de la gestion de la relation client",
	dashboard: "Tableau de bord",
	dashboardSubtitle: "Sous-titre du tableau de bord",
	database: "Base de données",
	date: "Date",
	dateOfBirth: "Date de naissance",
	dates: "Dates",
	datingAttendance: "Présence aux rendez-vous",
	dayOff: "Jour de congé",
	meeting: "Réunion",
	dayOffForAllEmployees: "Congé pour tous les employés",
	dayOffRemoved: "Congé supprimé",
	dayOffSavedForAllEmployees: "Congé enregistré pour tous les employés",
	days: "jours",
	daysLeft: "jours restants",
	daysOfWeek: "Jours de la semaine",
	daysWorked: "Jours travailles",
	deadLine: "Date limite",
	deadline: "Date limite",
	debt: "Dette",
	decline: "Décliner",
	deductions: "Retenues",
	defaultEnergyMax: "Énergie maximale par défaut",
	defaultEnergyMin: "Énergie minimale par défaut",
	defaultStream: "Flux par défaut",
	defaultStreams: "Flux par défaut",
	defaultStreamsDesc: "flux par défaut",
	delays: "Délai",
	delete: "Supprimer",
	deleteForEveryone: "Supprimer pour tout le monde",
	deletePermanently: "Supprimer définitivement",
	deleteRule: "Supprimer une règle",
	deleteSelected: "Supprimer la sélection",
	delivery: "Livraison",
	deliveryAddress: "Adresse de livraison",
	deliveryMethod: "Méthode de livraison",
	density: "Densité",
	department: "Département",
	departmentChatsHelp:
		"Associez les discussions de groupe et les canaux à ce service. Cela reste synchronisé avec le champ « département » de chaque discussion.",
	departmentLinkedChats: "Discussions du département",
	departments: "Départements",
	desc: "Description",
	description: "Description",
	designer: "Designer",
	detailedFilters: "Filtres détaillés",
	detailedSteps: "Étapes détaillées",
	details: "Détails",
	developed: "Développé",
	developedBy: "Développé par",
	difference: "Différence",
	diplomaImages: "Images de diplôme",
	directMessages: "Messages directs",
	disableSteps: "Désactiver les étapes",
	disabledSteps: "Étapes désactivées",
	disk: "Disque",
	distributionByPaymentType: "Répartition par type de paiement",
	domainFacility: "Installations",
	domainFinance: "Finance",
	domainHR: "RH",
	domainIT: "IT",
	domainOther: "Autre",
	domainSecurity: "Sécurité",
	done: "Terminé",
	download: "Télécharger",
	downloadAsContact: "Télécharger comme contact",
	draft: "Brouillon",
	dragToReorder: "Faites glisser pour réorganiser",
	dropFilesHere: "Déposez les fichiers ici",
	dropFilesHereOrClick: "Faites glisser les fichiers ici ou cliquez pour ajouter plus",
	dropzoneText: "Faites glisser les images ici ou cliquez pour sélectionner des fichiers",
	dueDate: "Date d'échéance",
	duration: "Durée",
	ecommerceDashboard: "Tableau de bord de la vente en ligne",
	edit: "Modifier",
	editComment: "Modifier le commentaire",
	editItem: "Modifier l'élément",
	editProject: "Modifier le projet",
	editRule: "Modifier une règle",
	edited: "Modifié",
	editingRule: "Modifier une règle",
	email: "E-mail",
	sendEmail: "Envoyer un e-mail",
	employee: "Employé",
	employeesPerDepartment: "Employés par département",
	employerExpenses: "Charges employeur",
	employmentStatus: "Statut d'emploi",
	emptyTrash: "Vider la corbeille",
	end: "Fin",
	endDate: "Date de fin",
	endDateMustBeLaterThanStartDate: "La date de fin doit être postérieure à la date de début",
	endDateShort: "Date de fin",
	endOfTraining: "Fin de la formation",
	endTime: "Heure de fin",
	ends: "Se termine",
	energyLevel: "Niveau d'énergie",
	energyScheduling: "Planification énergétique",
	enterAmount: "Entrer le montant",
	enterFeatureSuffix: "Entrer le suffixe de la fonction",
	enterFeatureText: "Entrer le texte de la fonction",
	enterGroupName: "Saisir le nom du groupe...",
	enterLabel: "Entrer le label",
	enterPersons: "Entrer le nombre de personnes",
	enterRuleName: "Entrer le nom de la règle",
	entry: "Entrée",
	error: "Erreur",
	errorMessage: "Une erreur s'est produite, veuillez réessayer.",
	errorOccurred: "Une erreur s'est produite",
	errorPageButton: "Ramenez-moi à la maison",
	errorPageHelpText: "Besoin d'aide ? Contactez notre équipe de support",
	errorPageSecondaryButton: "Signaler ce problème",
	errorPageSubtitle: "La page que vous recherchez n'existe pas",
	errorPageText:
		"Ne vous inquiétez pas, cela arrive aux meilleurs ! La page a peut-être été déplacée, supprimée, ou vous avez peut-être saisi une URL incorrecte. Remettons-vous sur la bonne voie.",
	errorPageTitle: "Oups ! Quelque chose s'est mal passé",
	errorUserNotFound: "Utilisateur non trouvé",
	estimatedHours: "Heures estimées",
	eventType: "Type d’événement",
	exit: "Sortie",
	expectedSalary: "Salaire attendu",
	expireDate: "Date d'expiration",
	expired: "Expiré",
	expiresOn: "Expire le",
	expiringIdCards: "Cartes d'identité expirantes",
	expiringPassports: "Passeports expirants",
	export: "Exporter",
	exportData: "Exporter les données",
	extraLarge: "Très grand",
	extraSmall: "Très petit",
	faqQuestions: "Questions FAQ",
	favorites: "Favoris",
	features: "Fonctionnalités",
	female: "Femme",
	fields: "Champs",
	file: "Fichier",
	fileHasBeenRemoved: "Le fichier a été supprimé",
	fileMovedToTrash: "Le fichier sera déplacé dans la corbeille",
	fileRestored: "Fichier restauré",
	fileWillBeMovedToTrash: "Le fichier sera déplacé dans la corbeille",
	files: "Fichiers",
	filesRestored: "Fichiers restaurés",
	filesWillBePermanentlyDeleted: "fichiers seront supprimés définitivement.",
	filter: "Filtre",
	filterBy: "Filtre",
	filters: "Filtres",
	finish: "Terminer",
	fired: "Renvoyé",
	firstIn: "Première entrée",
	firstName: "Prénom",
	forgotPassword: "Mot de passe oublié ?",
	forward: "Transférer",
	forwardMessage: "Transférer le message",
	forwarded: "Transféré",
	forwardedFrom: "Transféré de",
	fri: "Vendredi",
	from: "De",
	fromAttendanceLogs:
		"Rempli à partir des pointages pour cet employé et cette période ; modifiable.",
	fromDb: "Depuis la base de données",
	fromHrSettings: "Paramètres RH",
	gallery: "Galerie",
	genderDistribution: "Répartition par sexe",
	globalFilter: "Filtre global",
	globalSearchClose: "Fermer",
	globalSearchCmd_goCalendar_desc: "Événements du calendrier",
	globalSearchCmd_goCalendar_label: "Aller au calendrier",
	globalSearchCmd_goChat_desc: "Ouvrir la messagerie",
	globalSearchCmd_goChat_label: "Aller au chat",
	globalSearchCmd_goCrm_desc: "Gestion clients",
	globalSearchCmd_goCrm_label: "Aller au CRM",
	globalSearchCmd_goFinance_desc: "Module finance",
	globalSearchCmd_goFinance_label: "Aller à la finance",
	globalSearchCmd_goHr_desc: "Module RH",
	globalSearchCmd_goHr_label: "Aller aux RH",
	globalSearchCmd_goIt_desc: "Équipement informatique",
	globalSearchCmd_goIt_label: "Aller à l’IT",
	globalSearchCmd_goProjects_desc: "Base projets",
	globalSearchCmd_goProjects_label: "Aller aux projets",
	globalSearchCmd_goRadio_desc: "Musique et playlists",
	globalSearchCmd_goRadio_label: "Aller à la radio",
	globalSearchCmd_goTickets_desc: "Système de tickets",
	globalSearchCmd_goTickets_label: "Aller aux tickets",
	globalSearchCmd_goTodo_desc: "Tableaux et tâches",
	globalSearchCmd_goTodo_label: "Aller au Todo",
	globalSearchCmd_messageUser_desc: "Ouvrir le chat pour envoyer",
	globalSearchCmd_messageUser_label: "Message utilisateur",
	globalSearchCmd_newContact_desc: "Ajouter un client CRM",
	globalSearchCmd_newClient_label: "Nouveau client",
	globalSearchCmd_newOrder_desc: "Créer une commande",
	globalSearchCmd_newOrder_label: "Nouvelle commande",
	globalSearchCmd_newProject_desc: "Créer un projet",
	globalSearchCmd_newProject_label: "Nouveau projet",
	globalSearchCmd_newTask_desc: "Créer une tâche",
	globalSearchCmd_newTask_label: "Nouvelle tâche",
	globalSearchCmd_newTicket_desc: "Créer un ticket",
	globalSearchCmd_newTicket_label: "Nouveau ticket",
	globalSearchCommandBadge: "Commande",
	globalSearchCommands: "Commandes",
	globalSearchCopied: "Copié !",
	globalSearchCopyLink: "Copier le lien",
	globalSearchDirectMessage: "Message direct",
	globalSearchFilterAll: "Tout",
	globalSearchFilterCalendar: "Calendrier",
	globalSearchFilterChats: "Discussions",
	globalSearchFilterDevices: "Appareils",
	globalSearchFilterEcom: "E-commerce",
	globalSearchFilterFinance: "Finance",
	globalSearchFilterPeople: "Personnes",
	globalSearchFilterProjects: "Projets",
	globalSearchFilterRadio: "Radio",
	globalSearchFilterTickets: "Tickets",
	globalSearchFilterTodo: "Todo",
	globalSearchHidePreview: "Masquer l’aperçu",
	globalSearchNavigate: "Naviguer",
	globalSearchOpen: "Ouvrir",
	globalSearchOpenInNewTab: "Ouvrir dans un nouvel onglet",
	globalSearchPageBadge: "Page",
	globalSearchPlaceholder: "Rechercher dans APIT (utilisateurs, tickets, discussions, appareils…)",
	globalSearchPreviewAddress: "Adresse",
	globalSearchPreviewArtist: "Artiste",
	globalSearchPreviewChat: "Discussion",
	globalSearchPreviewCompany: "Entreprise",
	globalSearchPreviewCreated: "Créé",
	globalSearchPreviewDeviceId: "ID appareil",
	globalSearchPreviewEmail: "E-mail",
	globalSearchPreviewEmployeeNumber: "N° employé",
	globalSearchPreviewEnd: "Fin",
	globalSearchPreviewInfo: "Info",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "Lieu",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "Numéro",
	globalSearchPreviewOrderNumber: "Commande n°",
	globalSearchPreviewPhone: "Téléphone",
	globalSearchPreviewSent: "Envoyé",
	globalSearchPreviewStart: "Début",
	globalSearchPreviewUsername: "Nom d’utilisateur",
	globalSearchPreviewVendor: "Fournisseur",
	globalSearchPreviewVersion: "Version",
	globalSearchRecentSearches: "Recherches récentes",
	globalSearchRecentlyOpened: "Ouverts récemment",
	globalSearchSectionArtists: "Artistes",
	globalSearchSectionAttendanceDevices: "Pointeuses",
	globalSearchSectionBrands: "Marques",
	globalSearchSectionCalendarEvents: "Événements du calendrier",
	globalSearchSectionCameras: "Caméras",
	globalSearchSectionChats: "Discussions",
	globalSearchSectionClientGroups: "Groupes de clients",
	globalSearchSectionClients: "Clients",
	globalSearchSectionCpus: "Processeurs",
	globalSearchSectionDepartments: "Services",
	globalSearchSectionEcomCategories: "Catégories",
	globalSearchSectionFinanceCardIssuers: "Émetteurs de cartes",
	globalSearchSectionFinanceCards: "Cartes",
	globalSearchSectionFinanceCategories: "Catégories financières",
	globalSearchSectionFinanceTransactions: "Transactions",
	globalSearchSectionGpus: "GPU",
	globalSearchSectionKeyboards: "Claviers",
	globalSearchSectionLaptops: "Portables",
	globalSearchSectionMessages: "Messages",
	globalSearchSectionMice: "Souris",
	globalSearchSectionMonitors: "Écrans",
	globalSearchSectionOrders: "Commandes",
	globalSearchSectionPcs: "PC",
	globalSearchSectionPlaylists: "Playlists",
	globalSearchSectionPositions: "Postes",
	globalSearchSectionPrinters: "Imprimantes",
	globalSearchSectionProblems: "Problèmes",
	globalSearchSectionProducts: "Produits",
	globalSearchSectionProjects: "Projets",
	globalSearchSectionRams: "RAM",
	globalSearchSectionRoms: "Stockage",
	globalSearchSectionRooms: "Salles",
	globalSearchSectionRouters: "Routeurs",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "Logiciels",
	globalSearchSectionSwitches: "Commutateurs",
	globalSearchSectionTelephones: "Téléphones",
	globalSearchSectionTickets: "Tickets",
	globalSearchSectionTodoBoards: "Tableaux",
	globalSearchSectionTodoCategories: "Catégories",
	globalSearchSectionTodoTasks: "Tâches",
	globalSearchSectionTracks: "Morceaux",
	globalSearchSectionUsers: "Personnes",
	globalSearchSectionWarrantyProviders: "Fournisseurs de garantie",
	globalSearchSelectPreview: "Sélectionnez un élément à prévisualiser",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "Afficher l’aperçu",
	globalSearchSubtitle: "Rechercher dans tous les modules",
	globalSearchSuggest1: "Rechercher les tickets qui me sont assignés",
	globalSearchSuggest2: "Trouver un employé par e-mail",
	globalSearchSuggest3: "Rechercher dans les messages",
	globalSearchSuggest4: "Trouver un appareil par IP",
	globalSearchSuggest5: "Rechercher un client par téléphone",
	globalSearchSuggest6: "Aller aux projets",
	globalSearchTrySearchingFor: "Essayez de chercher",
	goBack: "Retour",
	goToMessage: "Aller au message",
	goToUserAttendanceTab: "Utilisateurs → présences",
	goToUserAttendanceTabTooltip: "Ouvrir cet employé dans RH Utilisateurs, onglet Présences",
	gpu: "GPU",
	grossSalary: "Salaire brut",
	group: "Groupe",
	groupChat: "Chat de groupe",
	groupChatWritePermissionDescription: "Tous les membres du chat peuvent ecrire des messages",
	groupChats: "Chats de groupe",
	groupName: "Nom du groupe (facultatif)",
	healthInsurance: "Assurance maladie",
	healthInsuranceBenefit: "Assurance maladie (avantage)",
	help: "Aide",
	hideAllSteps: "Masquer toutes les étapes",
	hideHistory: "Masquer l'historique",
	hideProjectDetails: "Masquer les détails du projet",
	hideTableColumnFilters: "Masquer les filtres de colonnes",
	hideTimeline: "Masquer la chronologie",
	high: "Haut",
	highestSpendingCustomers: "Clients les plus dépensiers",
	highlight: "Highlight",
	highlightFeature: "Highlight de fonction",
	history: "Histoire",
	historyTable: "Tableau historique",
	holiday: "Jour férié",
	holidayNonWorking: "Jour férié / non travaillé",
	hourlyRate: "Taux horaire",
	hourlyRateBaseLinked:
		"Met à jour le brut à partir du taux horaire × heures normales (si heures > 0).",
	hr2025RateReferenceTables: "Tableaux de référence des taux 2025",
	hrAccrualAnnualTotal: "Total annuel : {amount} jours",
	hrAccrualDaily: "Quotidien (÷ 365)",
	hrAccrualEachDay: "Chaque jour : +{amount} jours de congé",
	hrAccrualEachMonthFirst: "Chaque 1er du mois : +{amount} jours de congé",
	hrAccrualMethod: "Mode d'acquisition",
	hrAccrualMethodDesc: "Comment les congés s'accumulent",
	hrAccrualMonthly: "Mensuel (÷ 12, le 1er)",
	hrAccrualMonthlyEquivalent: "Équivalent mensuel : ~{amount} jours",
	hrAccrualPreview: "Aperçu de l'acquisition",
	hrArmeniaIncomeTaxCalculator: "Calculateur d'impôt sur le revenu (Arménie)",
	hrArmeniaTaxRates: "Taux d'imposition en Arménie",
	hrCalcSummaryGrossToNet:
		"Pour un salaire déclaré de {gross} AMD, vous recevrez {net} AMD nets après déduction de {deductions} AMD d'impôts et cotisations.",
	hrCalcSummaryNetToGross:
		"Pour recevoir {net} AMD nets, votre contrat doit indiquer un brut de {gross} AMD.",
	hrCalculationBreakdown: "Détail du calcul",
	hrCalculationDirection: "Sens du calcul",
	hrDefaultBenefitsDescription:
		"Ces valeurs par défaut s'appliquent à tous les calculs de paie sauf remplacement par employé.",
	hrDefaultMonthlyBenefits: "Avantages mensuels par défaut (AMD)",
	hrDesiredNetSalaryLabel: "Salaire net souhaité (à percevoir)",
	hrEmployeePensionLabel: "Retraite employé :",
	hrEmployeePensionRate: "Taux de cotisation retraite employé",
	hrEmployeePensionRateDesc: "Obligatoire pour les nés après 1973 (2,5 %)",
	hrEmployerPensionRate: "Taux de cotisation retraite employeur",
	hrEmployerPensionRateDesc: "Cotisation retraite employeur (2,5 %)",
	hrFailedToSaveSettings: "Échec de l'enregistrement des paramètres",
	hrGrossSalaryAMD: "Salaire brut (AMD)",
	hrGrossSalaryDescription: "Saisissez le montant figurant sur votre contrat de travail",
	hrGrossSalaryLabel: "Salaire brut (déclaré / contrat)",
	hrGrossSalaryRegistered: "Salaire brut (déclaré)",
	hrGrossToNet: "Brut → Net",
	hrHealthInsuranceAges: "Assurance maladie (18–65 ans)",
	hrHealthInsuranceBenefit: "Assurance maladie",
	hrHealthInsuranceBenefitDesc: "Cotisation employeur mensuelle à l'assurance santé (AMD)",
	hrHealthInsuranceEmployeeColumn: "Employé",
	hrHealthInsuranceEmployeeShare: "Assurance maladie (part employé)",
	hrHealthInsuranceStateColumn: "État",
	hrITSector: "Secteur IT (IR 10 %)",
	hrITSectorDesc: "Salarié d'une entreprise IT agréée",
	hrIncomeTax: "Impôt sur le revenu",
	hrIncomeTaxLabel: "Impôt sur le revenu :",
	hrIncomeTaxRate: "Taux d'impôt sur le revenu",
	hrIncomeTaxRateDesc: "Taux fixe de 20 % en Arménie depuis 2020",
	hrLeaveAccrualConfiguration: "Configuration de l'acquisition de congés",
	hrLiveRates: "Taux à jour",
	hrLunchCoverage: "Repas",
	hrLunchCoverageDesc: "Indemnité repas mensuelle (AMD)",
	hrMandatoryHealthInsurance: "Assurance maladie obligatoire (18–65 ans)",
	hrMandatoryHealthInsuranceDesc: "Inclure les tranches 2025 d'assurance maladie",
	hrMilitaryStampRate: "Taux de taxe militaire",
	hrMilitaryStampRateDesc: "Laisser 0 si non applicable",
	hrMonthlyFee: "Redevance mensuelle",
	hrNetSalaryDescription: "Indiquez le montant net que vous souhaitez percevoir",
	hrNetSalaryLabel: "Salaire net :",
	hrNetSalaryTakeHome: "Salaire net (à percevoir)",
	hrNetToGross: "Net → Brut",
	hrOvertimeRateMultiplier: "Multiplicateur des heures sup.",
	hrOvertimeRateMultiplierDesc: "ex. 1,5× = prime de 50 % sur les heures sup.",
	hrOvertimeRules: "Règles des heures supplémentaires",
	hrBreakIntervals: "Pauses",
	hrBreakIntervalsDesc:
		"Plages horaires fixes quotidiennes (ex. déjeuner) exclues du temps de travail pour tous. Vous pouvez en ajouter plusieurs.",
	hrBreakIntervalsEmpty: "Aucune pause configurée",
	hrBreakIntervalStart: "Début de la pause",
	hrBreakIntervalEnd: "Fin de la pause",
	hrAddBreakInterval: "Ajouter une pause",
	hrOvertimeThreshold: "Seuil des heures supplémentaires (h/jour)",
	hrOvertimeThresholdDesc: "Les heures au-delà déclenchent le taux des heures sup.",
	hrPensionMandatory: "Obligatoire / volontaire avant 07/2018 (5 %)",
	hrPensionNone: "Non participant (0 %)",
	hrPensionPost2018: "Volontaire après 07/2018 (5 %)",
	hrPensionSystem: "Régime de retraite",
	hrPensionSystemDesc: "Votre statut de cotisation à la retraite par capitalisation",
	hrSettingsPageSubtitle: "Configurer la paie, les congés et les règles de présence",
	hrSettingsPageTitle: "Paramètres RH",
	hrSettingsUpdatedSuccessfully: "Paramètres RH mis à jour avec succès",
	hrSickDaysPerYear: "Jours de maladie par an",
	hrSickDaysPerYearDesc: "Jours de congé maladie payés par année civile",
	hrSocialPaymentPension: "Cotisation sociale (retraite)",
	hrSocialTaxRate: "Taux de taxe sociale",
	hrSocialTaxRateDesc: "Actuellement 0 % en Arménie (remplacé par la retraite)",
	hrStampFee: "Taxe (fonds d'assurance militaire)",
	hrStampFeeTooltip: "Fonds d'assurance militaire — forfait échelonné selon la tranche de brut",
	hrStandardWorkSchedule: "Horaires de travail standard",
	hrStateHealthContribution: "Contribution de l'État à la santé",
	hrStateHealthContributionNote:
		"ajoutée par l'État à votre couverture santé (non déduite du salaire).",
	hrSuffixDays: "jours",
	hrSuffixHours: "h",
	hrSuffixTimes: "×",
	hrSummary: "Résumé",
	hrTabDefaultBenefits: "Avantages par défaut",
	hrTabLeaveAccrual: "Acquisition de congés",
	hrTabTaxCalculator: "Calculateur d'impôts",
	hrTabTaxesArmenia: "Impôts (Arménie)",
	hrTabWorkSchedule: "Horaires de travail",
	hrTaxPreviewTitle: "Aperçu des impôts (sur 500 000 AMD bruts)",
	hrTaxRatesDescription:
		"Les taux s'appliquent au salaire brut. Saisir en pourcentages (ex. 20 = 20 %).",
	hrTaxRatesDisclaimer:
		"Taux selon la législation arménienne 2025–2026. IR : 20 % standard, 10 % pour les entreprises IT agréées. Retraite : 5 % (obligatoire/volontaire pré-2018) ou 5 % forfaitaire (volontaire post-2018). Le taux majoré de 10 % s'applique aux participants obligatoires/pré-2018 au-dessus de 500 000 AMD. Vérifiez avec un expert-comptable.",
	hrThresholdWarning: "Alerte seuil",
	hrThresholdWarningText:
		"Votre salaire est proche d'un seuil de tranche (100k / 200k / 500k / 1M AMD). Les frais et l'assurance sautent de tranche : une petite hausse du brut peut réduire le net. Le calculateur affiche toujours le brut minimal pour le net demandé.",
	hrTickets: "Tickets RH",
	hrTotalDeductions: "Total des retenues",
	hrTotalEmployeeDeductionsLabel: "Total des retenues employé :",
	hrTransportAllowance: "Indemnité de transport",
	hrTransportAllowanceDesc: "Avantage transport mensuel (AMD)",
	hrVacationDaysPerYear: "Jours de congé par an",
	hrVacationDaysPerYearDesc: "Droit annuel complet (minimum Arménie : 20)",
	hrWorkingDayEnd: "Fin de la journée de travail",
	hrWorkingDayEndDesc:
		"Fin de service attendue. Les heures quotidiennes sont déduites des heures de début/fin",
	hrWorkingDayStart: "Début de la journée de travail",
	hrWorkingDayStartDesc: "Heure d'arrivée attendue pour la présence et les retards",
	hrWeekendDays: "Jours de week-end",
	hrWeekendDaysDesc: "Sélectionnez les jours de la semaine qui sont des week-ends non travaillés",
	hrWorkingDaysPerWeek: "Jours de travail par semaine",
	hrWorkingDaysPerWeekDesc: "Lun–Ven = 5, Lun–Sam = 6",
	hrWorkingHoursPerDay: "Heures de travail par jour",
	hrWorkingHoursPerDayDesc: "Heures normales avant les heures supplémentaires",
	href: "Lien",
	humanResources: "Ressources humaines",
	id: "ID",
	idCard: "Carte d'identité",
	idCardEndDate: "Date de fin de la carte d'identité",
	idCardNo: "N° de carte d'identité",
	idCardStartDate: "Date de début de la carte d'identité",
	idCart: "Carte d'identité",
	image: "Image",
	immediateSupervisor: "Superviseur immédiat",
	importance: "Importance",
	important: "Important",
	inProgress: "En cours",
	inSelectedPeriod: "dans la période sélectionnée",
	inStock: "En stock",
	in_progress: "En cours",
	inactive: "Inactif",
	inactiveTime: "Temps inactif",
	incident: "Incident",
	incomeTaxAmount: "Montant de l'impôt sur le revenu",
	incomeTaxRate: "Taux d'IR (%)",
	incomingCall: "Appel entrant",
	incomingVideoCall: "Appel vidéo entrant",
	incorrectLogin: "Vous avez entré un nom d'utilisateur ou un mot de passe incorrect",
	index: "#",
	inputInArmenian: "Saisir en arménien",
	inputInLatin: "Saisir en latin",
	inputInNumbers: "Entrez en chiffres",
	inputInRussian: "Saisir en russe",
	inputNumber: "Saisir un numéro",
	inputNumbers: "Entrez des nombres",
	instagramPosts: "Publications Instagram",
	insufficientVacationBalance: "Solde de congés insuffisant",
	interview1: "Entretien",
	interview2: "Présentation",
	interview3: "Formation",
	interview4: "Stage",
	interviewDate: "Date de l'entretien",
	interviewTime: "Heure de l'entretien",
	introSection: "Section d'introduction",
	invalidDate: "Date de livraison invalide",
	inventorySummary: "Résumé des stocks",
	ip: "IP",
	ipAddress: "Adresse IP",
	isActive: "Actif",
	isColor: "Couleur",
	isPrivateOffice: "Est-ce un bureau privé",
	isPublic: "Publice",
	itTickets: "Tickets IT",
	items: "éléments",
	justifiedAbsence: "Absence justifiée",
	keyText: "Texte clé",
	keyboards: "Claviers",
	label: "Étiquette",
	language: "Langue",
	languagePickerLabel: "Langue",
	large: "Grand",
	last7Days: "connectés ces 7 derniers jours",
	lastAction: "Dernière action",
	lastLogin: "Dernière connexion",
	lastName: "Nom de famille",
	lastOut: "Dernière sortie",
	lastPunch: "Dernier pointage",
	lasts: "Durée",
	latestCustomerOrders: "Dernières commandes clients",
	leader: "Leader",
	attendanceManagersFilter: "Managers",
	attendanceLeadersFilter: "Leaders",
	leaveBalance: "Solde de congés",
	linkCopied: "Lien copié",
	listeners: "Auditeurs",
	livingAddress: "Adresse de résidence",
	loading: "Chargement",
	loanDeductions: "Retenues de prêt",
	localCode: "Code local",
	logOut: "Déconnexion",
	login: "Connexion",
	loginButton: "Se connecter",
	loginFailed: "Échec de la connexion",
	loginFailedMessage: "Veuillez vérifier vos identifiants de connexion",
	loginSuccess: "Connexion réussie",
	loginSuccessMessage: "Vous vous êtes connecté avec succès",
	loginToStartSession: "Connectez-vous pour commencer une session",
	logout: "Se déconnecter",
	low: "Bas",
	lunchCoverage: "Repas",
	mac: "MAC",
	macAddress: "Adresse MAC",
	main: "Principal",
	itHierarchyAddLaptop: "Ajouter un ordinateur portable",
	itHierarchyAttachedPc: "PC associé",
	itHierarchyLaptopsUsingPart: "Ordinateurs portables utilisant cette pièce",
	itUsedInOtherPlaces: "Utilisé à d’autres endroits",
	mainInformation: "Informations de base",
	mainInfo: "Informations principales",
	contactInfo: "Coordonnées",
	personalInfo: "Informations personnelles",
	workingInfo: "Informations professionnelles",
	probation: "Période d'essai",
	educationInfo: "Formation",
	male: "Homme",
	manualAdjustments: "Ajustements manuels",
	manualAttendanceEntry: "Saisie manuelle",
	maps: "Cartes",
	maritalStatus: "État civil",
	markAllAsRead: "Tout marquer comme lu",
	markSelectedAsRead: "Marquer la sélection comme lue",
	maternityLeave: "Congé maternité",
	maxEnergy: "Énergie maximale",
	maxFilesReached: "Nombre maximum de fichiers atteint",
	maxSize: "Taille max",
	mediaGallery: "Galerie de médias",
	mediaGalleryDescription: "Description de la galerie de médias",
	mediator: "Médiateur",
	medium: "Moyen",
	members: "Membres",
	menu: "Menu",
	message: "Message",
	messages: "Messages",
	messagesByType: "Messages par type",
	messagesOverTime: "Messages au fil du temps (30 derniers jours)",
	militaryStampAmount: "Montant de la taxe militaire",
	militaryStampRate: "Taux de taxe militaire",
	minEnergy: "Énergie minimale",
	minute: "minute",
	minutes: "Minutes",
	missingInterval: "Intervalle manquant",
	mon: "Lundi",
	monitor: "Moniteur",
	monitors: "Moniteurs",
	month: "Mois",
	monthly: "Mensuel",
	mood: "Humeur",
	more: "Supplémentaire",
	moreDetailed: "Plus détaillé",
	moreThan: "Plus de",
	motherProject: "Projet mère",
	mounted: "Monté",
	mouses: "Souris",
	moveToTrash: "Déplacer vers la corbeille",
	movedToTrash: "Déplacé vers la corbeille",
	myActiveSteps: "Mes étapes actives",
	myInvolvement: "Mon implication",
	myProjects: "Mes projets",
	myRole: "Mon rôle",
	mySteps: "Mes étapes",
	myTickets: "Mes tickets",
	na: "N/A",
	name: "Nom",
	netCash: "Net en espèces",
	netOfficial: "Net officiel",
	netSalary: "Salaire net",
	newClients: "Nouveaux clients",
	newClientsOverTime: "Nouveaux clients au fil du temps (30 derniers jours)",
	newMessage: "Nouveau message",
	newProducts: "Nouveaux produits",
	newProject: "Nouveau projet",
	newProjects: "Nouveaux projets",
	newThisPeriod: "Nouveau cette période",
	newTicket: "Nouveau ticket",
	newTicketCreatedBy: "Nouveau ticket créé par",
	newTracks: "Nouvelles pistes",
	newTracksOverTime: "Nouvelles pistes au fil du temps (30 derniers jours)",
	next: "Suivant",
	nextComposition: "Prochaine composition",
	nextStep: "Étape suivante",
	noAccess: "Pas d'accès",
	noActiveSteps: "Aucune étape active",
	noBoardsFound: "Tableaux non trouvés",
	noCategoriesFound: "Catégories non trouvées",
	noCategoryDataAvailable: "Aucune donnée de catégorie disponible",
	noContent: "Il n'y a pas de contenu",
	noCustomerDataAvailable: "Aucune donnée client disponible",
	noData: "Aucune donnée disponible",
	noDataAvailable: "Aucune donnée disponible",
	noDataAvailableForSelectedPeriod: "Aucune donnée disponible pour la période sélectionnée",
	noDepartment: "Aucun département",
	noDepartments: "Aucun département",
	noDescription: "Description non trouvée",
	noEmail: "Pas d'email",
	noExpiringIdCards: "Aucune carte d'identité expirante",
	noExpiringPassports: "Aucun passeport expirant",
	noGroup: "Aucun groupe",
	noMediaDescription: "Description de média non trouvée",
	noMediaFound: "Aucun média trouvé",
	noMoreItems: "Aucun élément supplémentaire",
	noName: "Sans nom",
	noNeedStep45: "Pas besoin de l'étape 4-5",
	noNotifications: "Aucune notification",
	noOrdersInSelectedPeriod: "Aucune commande dans la période sélectionnée",
	noOvertimeRecords: "Aucune heure supplémentaire trouvée",
	noPaymentDataAvailable: "Aucune donnée de paiement disponible",
	noProjectsAssigned: "Aucun projet assigné",
	noProjectsAssignedOrInvolved: "Aucun projet assigné ou impliqué",
	noRecentContacts: "Aucun client récent",
	noRecentContent: "Aucun contenu récent",
	noRecentTickets: "Aucun billet récent",
	noRecentTracks: "Aucune piste récente",
	noRecipientInformation: "Aucune information sur le destinataire",
	noResponsible: "Pas de responsable",
	noResult: "Aucun résultat trouvé",
	noResults: "Aucun résultat trouvé",
	noResultsFound: "Aucun résultat trouvé",
	noRulesAdded: "Règles de planification non ajoutées",
	noStatusData: "Aucune donnée de statut disponible",
	noSystemDaysOffThisMonth: "Aucun jour de congé global ce mois-ci",
	noTaskDataAvailable: "Aucune donnée de tâche disponible",
	noTasksYet: "Aucune tâche",
	noTasksYetDescription: "Aucune tâche",
	noUpcomingBirthdays: "Pas d'anniversaires à venir",
	noUsersFound: "Aucun utilisateur trouvé",
	noUsersInDepartment: "Aucun utilisateur dans ce département",
	noWorkHourData: "Aucune donnée d'heure de travail",
	no_priority: "Sans priorité",
	nonWorking: "Jour non travaillé",
	none: "Aucun",
	notAvailable: "Produit non disponible",
	notCorrectLoginCredentials: "Identifiants de connexion incorrects",
	notLoggedInToday: "Pas connecté aujourd'hui",
	notPlaced: "Non placé",
	notPresent: "Absent",
	notResponded: "Sans réponse",
	notWorking: "Non travaillant",
	deviceProblems: "Problemes d'appareils",
	openTickets: "Tickets ouverts",
	note: "Remarque",
	nothingFound: "Rien trouvé",
	notifications: "Notifications",
	notificationsBellAria: "Ouvrir les notifications",
	similarTicketNotifications: "Notifications de billets similaires",
	number: "Nombre",
	"office-map": "Carte du bureau",
	officeMapActivatePlacement: "Activer le placement",
	officeMapAgent: "Agent",
	officeMapAll: "Tout",
	officeMapAttendanceDevice: "Appareil de présence",
	officeMapAttendanceDevices: "Présence",
	officeMapCable: "Câble",
	officeMapCableLinePlaced: "La ligne de câble a été placée",
	officeMapCableRemovedFromMap: "Le câble a été retiré de la carte",
	officeMapCables: "Câbles",
	officeMapCamera: "Caméra",
	officeMapCameras: "Caméras",
	officeMapNvr: "NVR",
	officeMapChat: "Chat",
	officeMapChatWasNotCreated: "Le chat n'a pas été créé",
	officeMapConnectToCamera: "Se connecter à la caméra",
	officeMapCpu: "CPU",
	officeMapDeactivate: "Désactiver",
	officeMapDeviceDetails: "Détails de l'appareil",
	officeMapDeviceId: "ID de l'appareil",
	officeMapDisableDragging: "Désactiver le glisser",
	officeMapEnableDragging: "Activer le glisser",
	officeMapEndDeviceOptional: "Appareil final (optionnel)",
	officeMapFailedToMoveCable: "Impossible de déplacer le câble",
	officeMapFailedToMoveItem: "Impossible de déplacer l'élément",
	officeMapFailedToMoveRoomArea: "Impossible de déplacer la zone de salle",
	officeMapFailedToOpenChat: "Impossible d'ouvrir le chat",
	officeMapFailedToPlaceItem: "Impossible de placer l'élément",
	officeMapFailedToPlaceUser: "Impossible de placer l'utilisateur",
	officeMapFailedToRemoveCable: "Impossible de retirer le câble",
	officeMapFailedToRemoveItem: "Impossible de retirer l'élément",
	officeMapFailedToRemoveRoomArea: "Impossible de retirer la zone de salle",
	officeMapFailedToSaveCableLine: "Impossible d'enregistrer la ligne de câble",
	officeMapFailedToSaveRoomArea: "Impossible d'enregistrer la zone de salle",
	officeMapFinishArea: "Terminer la zone",
	officeMapFinishCable: "Terminer le câble",
	officeMapForbidden: "Interdit",
	officeMapIp: "IP",
	officeMapItem: "Élément",
	officeMapItemPlaced: "Élément placé",
	officeMapItemRemovedFromMap: "L'élément a été retiré de la carte",
	officeMapLaptop: "Ordinateur portable",
	officeMapLaptops: "Ordinateurs portables",
	officeMapLayers: "Calques",
	officeMapLinkedItRoom: "Salle IT liée",
	officeMapLive: "Direct",
	officeMapMac: "MAC",
	officeMapMin: "min",
	officeMapMonitors: "Moniteurs",
	officeMapNetworkCable: "Câble réseau",
	officeMapNoDevicesInArea: "Aucun appareil ou utilisateur n'est placé dans cette zone.",
	officeMapNoPermissionToPlaceItem: "Vous n'avez pas l'autorisation de placer cet élément.",
	officeMapNoPermissionToPlaceNetworkCable:
		"Vous n'avez pas l'autorisation de placer un câble réseau.",
	officeMapNoPermissionToPlaceRoomArea:
		"Vous n'avez pas l'autorisation de placer une zone de salle.",
	officeMapNoPermissionToRemoveItem:
		"Vous n'avez pas l'autorisation de retirer cet élément de la carte.",
	officeMapNoPermissionToRemoveNetworkCable:
		"Vous n'avez pas l'autorisation de retirer le câble réseau de la carte.",
	officeMapNoPermissionToRemoveRoomArea:
		"Vous n'avez pas l'autorisation de retirer la zone de salle de la carte.",
	officeMapNotAvailable: "N/D",
	officeMapNotConnected: "Non connecté",
	officeMapPc: "PC",
	officeMapPcs: "PC",
	officeMapPlacement: "Placement",
	officeMapPleaseSelectItemFirst: "Veuillez d'abord sélectionner un élément",
	officeMapPleaseSelectRoomFirst: "Veuillez d'abord sélectionner une salle",
	officeMapPoints: "Points",
	officeMapPorts: "Ports",
	officeMapPrinted: "Imprimé",
	officeMapPrinters: "Imprimantes",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "Retirer de la carte",
	officeMapRom: "ROM",
	officeMapRoomArea: "Zone de salle",
	officeMapRoomAreaPlaced: "La zone de salle a été placée",
	officeMapRoomAreaRemovedFromMap: "La zone de salle a été retirée de la carte",
	officeMapRoomAreas: "Salles",
	officeMapRoomContents: "Contenu de la salle",
	officeMapRouter: "Routeur",
	officeMapRouters: "Routeurs",
	officeMapSelectItem: "Sélectionner un élément",
	officeMapSelectRoom: "Sélectionner une salle",
	officeMapSpeed: "Vitesse",
	officeMapStartDeviceOptional: "Appareil de départ (optionnel)",
	officeMapSwitches: "Commutateurs",
	officeMapTelephone: "Téléphone",
	officeMapTelephones: "Téléphones",
	officeMapUnknown: "Inconnu",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "L'utilisateur a été placé sur la carte",
	officeMapUsers: "Utilisateurs",
	officeMapViewContents: "Voir le contenu",
	officeMapViewFullDetails: "Voir tous les détails",
	offline: "Hors ligne",
	offlinePaymentOnly: "Paiement hors ligne uniquement",
	oldProject: "Ancien projet",
	onSale: "En vente",
	onSecond: "À la seconde",
	onTime: "À l'heure",
	onTimeRate: "Taux de ponctualite",
	oneOf: "Un de",
	open: "Ouvrir",
	openBoard: "Ouvrir Board",
	openDate: "Date d'ouverture",
	openInModal: "Ouvrir dans la fenêtre modale",
	openInNewTab: "Ouvrir dans un nouvel onglet",
	openNavigation: "Ouvrir la navigation",
	openedDate: "Date d'ouverture",
	optional: "Optionnel",
	orClickToSelect: "ou cliquez pour sélectionner des fichiers",
	order: "Commande",
	orderNumber: "Numéro de commande",
	orders: "Commandes",
	ordersCart: "Tableau des commandes",
	otAfterWork: "Heures supp. après fin de poste",
	otBeforeWork: "Heures supp. avant prise de poste",
	otherBenefits: "Autres avantages",
	otherDeductions: "Autres retenues",
	otherInsurance: "Autre assurance",
	outOfStock: "Rupture de stock",
	overdue: "En retard",
	overtimeComment: "Commentaire heures supp.",
	overtimeDays: "Jours avec heures supplémentaires",
	overtimeHours: "Heures supplémentaires",
	overtimeRate: "Taux des heures sup.",
	overtimeSummary: "Récapitulatif heures sup.",
	overtimeTotal: "Total heures sup.",
	overview: "Aperçu",
	owner: "Propriétaire",
	ownership: "Propriété",
	pageNotFound: "Page non trouvée",
	pageNotFoundDescription:
		"Oups ! La page que vous recherchez n'existe pas ou a été déplacée. Elle a peut-être été supprimée, son nom a changé ou elle est temporairement indisponible.",
	pages: "Pages",
	paid: "Payé",
	paidStatus: "Statut de paiement",
	paidTimeOff: "Congé payé",
	paidTimeOffDays: "Jours de congé payé",
	parent: "Parent",
	parentCategory: "Catégorie parente",
	parentDepartment: "Département parent",
	parentTask: "Tâche parente",
	parentType: "Type de parent",
	parentUser: "Utilisateur parent",
	participant: "Participant",
	passportEndDate: "Date d'expiration du passeport",
	passportImages: "Images de passeport",
	passportNo: "N° de passeport",
	passportStartDate: "Date de début du passeport",
	password: "Mot de passe",
	pause: "Pause",
	paused: "En pause",
	payDate: "Date de paiement",
	paymentMethod: "Méthode de paiement",
	paymentMethods: "Méthodes de paiement",
	paymentSystem: "Système de paiement",
	payrollBreakdown: "Détail de la paie",
	payrollCalcError: "Le calcul de la paie a échoué.",
	payrollCalcHint:
		"L'employé et la période sont obligatoires. Cliquez pour calculer et enregistrer les totaux de paie.",
	payrollCalcMissingFields: "Veuillez sélectionner l'employé, le début et la fin de période.",
	payrollCommentsForEmployee: "Commentaires pour l'employé",
	payrollGeneratedFromAttendance: "Paie générée à partir des présences",
	payrollHealthInsurancePremium: "Assurance maladie (prime)",
	payrollIndexLabel: "N°",
	payrollIndexPlaceholder: "Index",
	payrollInternalNotes: "Notes internes",
	payrollNotesSection: "Notes",
	payrollType: "Type de paie",
	payrollUsesHrSettings:
		"Les heures sup., les taux d'imposition et les avantages par défaut (repas, transport, santé) suivent les paramètres RH (Système → Paramètres RH).",
	pc: "Ordinateur",
	pcHealth: "Santé du PC",
	pcs: "PC",
	pdf: "PDF",
	penalties: "Pénalités",
	pending: "En attente",
	pensionAmount: "Montant de retraite",
	pensionRate: "Taux de retraite",
	periodEnd: "Date de fin",
	periodStart: "Date de début",
	permInput_calendarEvent_overlayCustomCalendars: "Calendriers personnalisés (filtres)",
	permInput_calendarEvent_overlayIt: "Calendriers IT (garantie PC)",
	permInput_calendarEvent_overlayPeople: "Calendriers personnes (RH)",
	permInput_calendarEvent_overlayReminders: "Superposition des rappels",
	permInput_calendarEvent_overlayTasks: "Tâches (couches de priorité)",
	permInput_calendarEvent_overlayTickets: "Superposition tickets (echeances par domaine)",
	permInput_chat_attachFile: "Joindre des fichiers",
	permInput_chat_calling: "Appel audio",
	permInput_chat_pin: "Epingler les messages",
	permInput_chat_searchFiles: "Rechercher dans les fichiers",
	permInput_chat_searchMessages: "Rechercher dans les messages",
	permInput_chat_sendMessage: "Envoyer des messages",
	permInput_chat_star: "Marquer les messages",
	permInput_chat_videoCalling: "Appel video",
	permModuleCrud_download: "Téléchargement calendrier (import .ics)",
	permModuleCrud_upload: "Envoi calendrier (export .ics)",
	permanentDelete: "Suppression définitive ?",
	permission: "Permission",
	permissions: "Permissions",
	persons: "Personnes",
	phone: "Téléphone",
	photo: "Photo",
	photos: "Photos",
	pickEmoji: "Choisissez un emoji",
	pinnedMessages: "Messages epingles",
	placed: "Placé",
	placedState: "Statut placé",
	placeholder: "Espace réservé",
	platformDashboard: "Tableau de bord de la plateforme",
	platformSpecificSettings: "Paramètres spécifiques à la plateforme",
	platforms: "Plateformes",
	audioPlaybackSpeed: "Vitesse de lecture : {rate}. Cliquez pour modifier.",
	playbackMute: "Couper le son",
	playbackUnmute: "Réactiver le son",
	playbackVoiceMessage: "Message vocal",
	playbackVideoMessage: "Message vidéo",
	previewVoiceMessage: "Écouter le message vocal avant envoi",
	play: "Jouer",
	playStatus: "État de lecture",
	playing: "Lecture",
	playingComposition: "Composition en cours de lecture",
	playingHistory: "Historique de lecture",
	playlist: "Liste de lecture",
	playlistStatistics: "Statistiques des playlists",
	playlistsWithAds: "playlists avec publicités",
	playlistsWithoutAds: "playlists sans publicités",
	podcast: "Podcast",
	podcastStreams: "flux de podcasts",
	podcasts: "Podcasts",
	ports: "Ports",
	position: "Poste",
	positionReviewDate: "Date de révision du poste",
	preDefinedFilters: "Filtres prédéfinis",
	preview: "Aperçu",
	previous: "Précédent",
	previousStep: "Étape précédente",
	price: "Prix",
	priceB2b: "Prix d'entreprise",
	priceBasic: "Prix de base",
	priceGroup1: "Groupe de prix 1",
	priceGroup2: "Groupe de prix 2",
	priceGroup3: "Groupe de prix 3",
	priceLists: "Listes de prix",
	printedCount: "Nombre imprimé",
	printer: "Imprimante",
	printers: "Imprimantes",
	priority: "Priorité",
	priorityDescription: "Règles de planification temps",
	private: "Privé",
	privateChat: "Chat privé",
	privateChatDescription: "Seuls les utilisateurs sélectionnés peuvent voir et rejoindre ce chat",
	problem: "Problème",
	problemDescription: "Description du problème",
	problemGroup: "Groupe de problèmes",
	problemGroupSupervisorsPlaceholder:
		"Utilisateurs responsables du traitement des tickets dans ce groupe de problèmes",
	problemGroupSupervisorsTab: "Superviseurs",
	processTime: "Temps de traitement",
	processing: "Traitement",
	progress: "Progression",
	product: "Produit",
	productCare: "Soin du produit",
	products: "Produits",
	productsLinked: "Produits liés",
	project: "Projet",
	projectChanges: "Modifications du projet",
	projectDeadline: "Date limite du projet",
	projectDetails: "Détails du projet",
	projectEndDate: "Date de fin de projet",
	projectID: "ID de projet",
	projectPartition: "Partition du projet",
	projectPrice: "Prix du projet",
	projectPrice2: "Prix du projet",
	projectStartDate: "Date de début de projet",
	projectType: "Type de projet",
	projectTypes: "Types de projets",
	projects: "Projets",
	promoCode: "Code promo",
	promoCodes: "Codes promo",
	promoCodesAndCertificates: "Codes promo et certificats",
	promotions: "Promotions",
	propertyNumber: "Numéro de propriété",
	providing: "Fournir",
	punchActivity: "Activité de pointage",
	pto: "Congé payé",
	partial: "Partiel",
	quantity: "Quantité",
	radioDashboard: "Tableau de bord radio",
	radioManagementOverview: "Aperçu de la gestion de diffusion radio",
	radioStatistics: "Statistiques radio",
	raises: "Augmentations",
	ram: "RAM",
	rate: "Taux",
	rating: "Note",
	readOnly: "Lecture seule",
	readOnlyChatNotice:
		"Ce chat est en lecture seule pour les membres. Seuls les administrateurs peuvent ecrire des messages.",
	readyToGetStarted: "Prêt à commencer",
	recalculatePayroll: "Recalculer la paie",
	recentClients: "Clients récents",
	recentContent: "Contenu récent",
	recentMessages: "Messages récents",
	recentOrders: "Commandes récentes",
	recentTickets: "Billets récents",
	recentTracks: "Pistes récentes",
	refresh: "Actualiser",
	registeredAddress: "Adresse enregistrée",
	regularHours: "Heures normales",
	regularHoursHrScheduleHint:
		"Rempli automatiquement depuis les paramètres RH : jours ouvrés dans la période × heures par jour. Modifiable.",
	regularPlaylists: "Playlists régulières",
	relatedList: "Liste associée",
	relatedObjects: "Objets liés",
	relatedProducts: "Produits liés",
	relatedTasks: "Tâches liées",
	relations: "Relations",
	remainingVacation: "Congés restants",
	remote: "À distance",
	remoteWorkDays: "Jours de télétravail",
	remove: "Retirer",
	removeFromList: "Retirer de la liste",
	removeItem: "Supprimer l'élément",
	removed: "Supprimé",
	reopen: "Rouvrir",
	replaceableProduct: "Produit interchangeable",
	replaceableProducts: "Produits remplaçables",
	replied: "Répondu",
	reply: "Répondre",
	request: "Demande",
	requestedForUser: "Demandé pour",
	reset: "Réinitialiser",
	responseTimeDistribution: "Distribution du temps de réponse",
	responsible: "Responsable",
	responsibleAndUsers: "Responsables et utilisateurs",
	restoreSelected: "Restaurer les sélectionnés",
	restored: "Restauré",
	returning: "Récurrent",
	revenue: "Revenu",
	revenueOverview: "Aperçu des revenus",
	review: "Revue",
	rightNow: "À l'instant",
	role: "Rôle",
	rom: "ROM",
	room: "Chambre",
	routers: "Routeurs",
	rpaPrice: "Prix du travail du département RPA",
	ruleName: "Nom de la règle",
	salary: "Salaire",
	salaryReviewDate: "Date de révision du salaire",
	sale: "Vente",
	salePrice: "Prix de vente",
	salesBreakdownByCategory: "Répartition des ventes par catégorie",
	salesPerformanceOverTime: "Performance des ventes dans le temps",
	sat: "Samedi",
	save: "Sauvegarder",
	saveChanges: "Enregistrer les modifications",
	saveComment: "Enregistrer le commentaire",
	saved: "Sauvegardé",
	schedulingDisabled: "Planification désactivée",
	schedulingEnabled: "Planification activée",
	schedulingRules: "Règles de planification temps",
	search: "Rechercher",
	searchByNameOrId: "Recherche par nom ou ID…",
	searchChat: "Rechercher un chat...",
	searchChatGroups: "Rechercher des groupes de discussion...",
	searchConversations: "Rechercher les conversations...",
	searchResults: "Résultats de recherche",
	searchUsers: "Rechercher des utilisateurs...",
	secondary: "Secondaire",
	seconds: "secondes",
	securityAcknowledge: "Accuser réception",
	securityActions: "Actions",
	securityActiveBadge: "Actif",
	securityActiveSessions: "Sessions actives",
	securityActivityStatClicks: "Clics",
	securityActivityStatKeys: "Touches",
	securityActivityStatMoves: "Mouvements",
	securityActivityTimeline: "Chronologie d’activité",
	securityAdminNotes: "Notes admin",
	securityAdminNotesDevice: "Notes internes sur cet appareil...",
	securityAgentHeartbeat: "Battement de l’agent",
	securityAlertClipPlural: "clips d’alerte sur cette page",
	securityAlertClipSingular: "clip d’alerte sur cette page",
	securityAlertCount: "alerte",
	securityAlertCountPlural: "alertes",
	securityAlertDrawerNoMedia:
		"Aucun média lié. L’agent a besoin de FFmpeg. Sous Windows PATH ou FFMPEG_PATH. Voir les journaux.",
	securityAlertDrawerVideoFailed:
		"Commande vidéo envoyée mais aucun fichier. Erreur possible de l’agent — voir les journaux.",
	securityAlertDrawerVideoPending:
		"Vidéo en cours d’enregistrement, bientôt visible. L’agent capture et téléverse.",
	securityAlertRecordings: "Enregistrements d'alerte",
	securityAlertRecordingsOnly: "Enregistrements d’alerte seulement",
	securityAlertSt_acknowledged: "accusé réception",
	securityAlertSt_false_positive: "faux positif",
	securityAlertSt_open: "ouvert",
	securityAlertSt_resolved: "résolu",
	securityAlertsTitle: "Alertes sécurité",
	securityAllDevices: "Tous les appareils",
	securityAllEventTypes: "Tous les types",
	securityAllRules: "Toutes les règles",
	securityAllSeverities: "Toutes les gravités",
	securityAllStatuses: "Tous les statuts",
	securityAppProcessTracking: "Apps / processus",
	securityAppTracking: "Apps",
	securityAppUsageToday: "Utilisation d’apps aujourd’hui (min)",
	securityAssignedUser: "Utilisateur assigné",
	securityBadgeAlertText: "ALERTE",
	securityBadgeApp: "app",
	securityBadgeApps: "Apps",
	securityBadgeCapture: "capture",
	securityBadgeFiles: "Fichiers",
	securityBadgeOff: "off",
	securityBadgeScr: "capt.",
	securityBadgeScreenshot: "Capture",
	securityBadgeVideo: "Vidéo",
	securityBadgeWeb: "Web",
	securityCapture: "Capture",
	securityCaptureEnabledMaster: "Capture activée (maître)",
	securityCaptureEverySeconds: "Intervalle (secondes)",
	securityCaptureMasterSwitch: "Capture activée (interrupteur maître)",
	securityCaptureModes: "Modes de capture",
	securityCaptureOffAlertBody:
		"Capture désactivée au niveau appareil, remplace la politique. Alertes sans captures ni vidéo.",
	securityCaptureOffAlertTitle: "Remplacement capture : OFF",
	securityCaptureRecorded: "Capture enregistrée",
	securityCaptureWhenOnDesc: "Si activé, captures et vidéo possibles ; désactiver coupe les deux",
	securityChartMinutes: "minutes",
	securityChartVisits: "visites",
	securityClearFilters: "Effacer les filtres",
	securityClickLeft: "G",
	securityClickMiddle: "M",
	securityClickPlain: "clic",
	securityClickRight: "D",
	securityClipWord: "Clip",
	securityConnectedDevices: "Appareils connectés",
	securityCreated: "Créé",
	securityDeleteDevice: "Supprimer l'appareil",
	securityDeleteDeviceConfirm: "Êtes-vous sûr de vouloir supprimer",
	securityDeleteDeviceNote:
		"Cela supprime uniquement l'enregistrement du dispositif de sécurité. Le profil PC dans IT ne sera pas affecté.",
	securityDeleteDeviceTitle: "Supprimer l'appareil de sécurité",
	securityDeleteMedia: "Supprimer",
	securityDeletePolicyConfirm: "Supprimer cette politique ?",
	securityDevice: "Appareil",
	securityDeviceFallback: "Appareil",
	securityDeviceIdLabel: "ID appareil",
	securityDeviceNotFound: "Appareil introuvable",
	securityDeviceSettings: "Paramètres",
	securityDeviceSettingsHint: "Remplace la politique active pour cet appareil. Héritée si vide.",
	securityDevicesBreadcrumb: "Appareils",
	securityDevicesTitle: "Appareils de sécurité",
	securityDevicesWithAlerts: "Appareils avec alertes",
	securityDividerCapture: "Capture",
	securityDividerNotes: "Notes",
	securityDividerTracking: "Suivi",
	securityDuration: "Durée",
	securityEg15: "ex. 15",
	securityEg30: "ex. 30",
	securityEg300: "ex. 300",
	securityEg5: "ex. 5",
	securityEg60: "ex. 60",
	securityEnabled: "Activé",
	securityEnd: "Fin",
	securityEventFlushSeconds: "Vidage événements (s)",
	securityEventsCount: "événement",
	securityEventsCountPlural: "événements",
	securityEvtAppProcess: "App / processus",
	securityEvtAppUsage: "Utilisation d’app",
	securityEvtFileEvent: "Événement fichier",
	securityEvtHeartbeat: "Battement",
	securityEvtInputActivity: "Activité de saisie",
	securityEvtKeystroke: "Frappe",
	securityEvtMouseClick: "Clic souris",
	securityEvtSessionEnd: "Fin de session",
	securityEvtSessionStart: "Début de session",
	securityEvtSystemBoot: "Démarrage système",
	securityEvtSystemShutdown: "Arrêt système",
	securityEvtUsb: "Événement USB",
	securityEvtUserLogin: "Connexion utilisateur",
	securityEvtUserLogout: "Déconnexion utilisateur",
	securityEvtWebVisit: "Visite web",
	securityEvtWorkstationLock: "Écran verrouillé",
	securityEvtWorkstationUnlock: "Écran déverrouillé",
	securityFailedLoadOverview: "Échec du chargement de l’aperçu sécurité",
	securityFailedSavePolicy: "Échec de l’enregistrement de la politique",
	securityFalsePositiveBtn: "Faux positif",
	securityFileEventTracking: "Événements fichiers",
	securityFilterByDate: "Filtrer par date",
	securityFilterDateRange: "Filtrer par plage de dates",
	securityFilteredSuffix: "(filtré)",
	securityFps: "IPS",
	securityHostname: "Nom d’hôte",
	securityInputActivityCounts: "Activité de saisie (compteurs)",
	securityInputKeystrokeClickTracking: "Suivi frappes/clics",
	securityInputModeActivityCountsShort: "Activité uniquement — compteurs",
	securityInputModeActivityOnly: "Activité uniquement (compteurs)",
	securityInputModeDisabled: "Désactivé",
	securityInputModeDisabledShort: "Désactivé — pas de métriques",
	securityInputModeEventsOnly: "Événements uniquement",
	securityInputModeEventsStream: "Événements uniquement — flux brut",
	securityInputModeFullDetail: "Détail complet (frappes + clics)",
	securityInputModeFullKeystrokes: "Détail complet — frappes et clics",
	securityInputModeShort: "Mode saisie",
	securityInputTrackingMode: "Mode suivi saisie",
	securityInternalNotesPlaceholder: "Notes internes...",
	securityKeyCharPrefix: "touche :",
	securityLastSeen: "Dernière activité",
	securityLatestClip: "Dernier clip",
	securityLinkedItPc: "PC IT lié :",
	securityLiveLoadingSub: "Connexion à l’agent — l’aperçu de l’écran apparaîtra sous peu.",
	securityLiveOfflineHint: "Appareil hors ligne — le direct nécessite un agent connecté.",
	securityLivePressStart: "Appuyez sur Démarrer le direct pour ouvrir le flux.",
	securityLiveScreenAlt: "Écran en direct",
	securityLiveStatusLive: "EN DIRECT",
	securityLiveStatusStandby: "Veille",
	securityLiveStreamHint: "Flux en demi-résolution, jusqu’à 10 ips. Agent v1.4.0+ avec jimp.",
	securityLiveWaitingFrames: "Chargement du direct…",
	securityLoggedInSince: "Connecté depuis",
	securityLoggedOutSince: "Dernière déconnexion",
	securityMediaPrefix: "Média",
	securityMediaTitle: "Médias sécurité",
	securityMiddleClick: "clic milieu",
	securityModuleErrorTitle: "Erreur du module sécurité",
	securityName: "Nom",
	securityNearbyScreenshots: "Captures à proximité",
	securityNever: "Jamais",
	securityNewMediaBadge: "nouveau",
	securityNewPolicy: "Nouvelle politique",
	securityNoActivityEvents: "Aucun événement",
	securityNoAlertRecordingsPage: "Aucun enregistrement d’alerte sur cette page",
	securityNoAlertsForDevice: "Aucune alerte pour cet appareil",
	securityNoAlertsFound: "Aucune alerte",
	securityNoDevicesFound: "Aucun appareil",
	securityNoEventsMatchFilter: "Aucun événement ne correspond",
	securityNoOpenAlerts: "Aucune alerte ouverte",
	securityNoPoliciesConfigured: "Aucune politique. Créez-en une pour commencer la surveillance.",
	securityNoPreview: "Aperçu indisponible",
	securityNoRiskyDevices: "Aucun appareil à risque",
	securityNoScreenshotsFound: "Aucune capture",
	securityNoScreenshotsYet: "Aucune capture pour l’instant",
	securityNoSessionsFound: "Aucune session",
	securityNoSessionsRecorded: "Aucune session enregistrée",
	securityNoUserSession: "Aucune session",
	securityNoUserSessionLiveHint:
		"Le PC est allumé mais aucun utilisateur n'est connecté. La vue en direct et les captures d'écran sont indisponibles.",
	securityNoUserSessionTitle: "Aucun utilisateur connecté",
	securityNoVideoSegmentsFound: "Aucun segment vidéo",
	securityNoVideosYet: "Aucun segment vidéo pour l’instant",
	securityOS: "OS",
	securityOnlineDevices: "Appareils en ligne",
	securityOpenAlerts: "Alertes ouvertes",
	securityOpenPcRecord: "Ouvrir la fiche PC",
	securityOverrideOff: "OFF",
	securityOverrideOn: "ON",
	securityOverridePrefix: "Remplacement :",
	securityOverviewTitle: "Aperçu sécurité",
	securityPageOf: "page",
	securityPolActivityTrackingDivider: "Suivi d’activité",
	securityPolAfterHoursStart: "Début hors heures",
	securityPolAlertClipLength: "Durée du clip d’alerte (s)",
	securityPolAlertScore: "Score d’alerte (0–100)",
	securityPolAlertSeverity: "Gravité de l’alerte",
	securityPolAlertVideoDivider: "Enregistrement vidéo d’alerte",
	securityPolAlertVideoInfo:
		"Si une règle déclenche une alerte, l’agent enregistre une vidéo bureau avec les réglages ci-dessous, identiques pour toutes les règles.",
	securityPolAllowedHoursDivider: "Heures de capture autorisées",
	securityPolBadgeAlert: "Alerte",
	securityPolBlockedApps: "Applications bloquées",
	securityPolBlockedAppsPh: "ex. telegram, discord, torrent",
	securityPolBlockedDomains: "Domaines bloqués",
	securityPolBlockedDomainsPh: "ex. torrent-site.com, telegram.org",
	securityPolBreadcrumbPolicies: "Politiques",
	securityPolBulkThreshold: "Seuil d’événements fichiers en masse (événements/lot)",
	securityPolBulkThresholdDesc: "Nombre d’événements fichiers destructeurs par lot pour déclencher",
	securityPolCollectInputMetrics: "Collecter les métriques de saisie",
	securityPolCollectInputMetricsDesc:
		"Compteurs souris/clavier uniquement (pas de contenu des frappes)",
	securityPolCreateAlert: "Créer une alerte",
	securityPolCreateAlertDesc: "Si la règle correspond, alerte sécurité (vidéo = onglet Capture)",
	securityPolDescription: "Description",
	securityPolEditPolicy: "Modifier la politique",
	securityPolEnableRule: "Activer la règle",
	securityPolEventsRetention: "Rétention événements (jours)",
	securityPolEventsRetentionDesc: "Enregistrements d’activité plus anciens seront purgés",
	securityPolExcludedDomains: "Domaines exclus",
	securityPolExcludedDomainsPh: "ex. online-banking.com",
	securityPolExcludedProcesses: "Noms de processus exclus",
	securityPolExcludedProcessesPh: "ex. 1Password, Bitwarden",
	securityPolInputActivityCounts: "Activité uniquement — compteurs souris/clavier",
	securityPolInputDisabledNoTrack: "Désactivé — pas de suivi saisie",
	securityPolInputEventsCount: "Événements uniquement — compteurs de touches",
	securityPolInputFullDetail: "Détail complet — frappes et positions de clic",
	securityPolInputModeLabel: "Mode de suivi de saisie",
	securityPolInputTrackingDivider: "Suivi de saisie",
	securityPolMaskSensitive: "Masquer les fenêtres sensibles (mots de passe, banque)",
	securityPolMaskSensitiveDesc: "Pas de captures pour les apps/fenêtres exclues",
	securityPolMaxFps: "IPS max",
	securityPolMediaRetention: "Rétention médias (jours)",
	securityPolMediaRetentionDesc: "Captures et vidéos plus anciennes seront supprimées",
	securityPolNewSecurityPolicy: "Nouvelle politique de sécurité",
	securityPolNotifyUsersDesc:
		"Les utilisateurs sélectionnés recevront une notification dans l'application lorsqu'une règle de cette politique se déclenche.",
	securityPolNotifyUsersLabel: "Notifier les administrateurs lors du déclenchement",
	securityPolNotifyUsersPh: "Chercher des utilisateurs à notifier…",
	securityPolPolicyName: "Nom de la politique",
	securityPolPolicyNamePh: "ex. Politique équipe dev",
	securityPolPriority: "Priorité",
	securityPolPriorityDesc: "Nombre plus élevé = évalué en premier",
	securityPolRecordVideoOnAlert: "Enregistrer une vidéo sur alerte",
	securityPolRecordVideoOnAlertDesc: "Si désactivé, alertes sans vidéo",
	securityPolRuleAfterHoursDesc: "Se déclenche en cas d’activité hors plage horaire définie.",
	securityPolRuleAfterHoursLabel: "Activité hors heures",
	securityPolRuleBlockedAppDesc:
		"Se déclenche si l’utilisateur surveillé ouvre une app de la liste.",
	securityPolRuleBlockedAppLabel: "Application bloquée",
	securityPolRuleBlockedDomainDesc:
		"Se déclenche si l’utilisateur surveillé visite un domaine de la liste.",
	securityPolRuleBlockedDomainLabel: "Domaine bloqué",
	securityPolRuleBulkFileDesc:
		"Se déclenche si beaucoup de suppressions/renommages/déplacements de fichiers en un lot.",
	securityPolRuleBulkFileLabel: "Opérations fichiers en masse",
	securityPolRuleUsbDesc: "Se déclenche si un USB est branché sur un appareil surveillé.",
	securityPolRuleUsbLabel: "Stockage USB détecté",
	securityPolRulesIntro:
		"Les règles définissent la violation et le score. Si « Créer une alerte » est actif, alerte sécurité ; la vidéo suit l’onglet Capture pour toutes les règles.",
	securityPolSavePolicy: "Enregistrer la politique",
	securityPolScope: "Portée",
	securityPolScopeDepartment: "Service",
	securityPolScopeDevice: "Appareils spécifiques",
	securityPolScopeGlobal: "Global — tous les appareils",
	securityPolScopeUser: "Utilisateurs spécifiques",
	securityPolTabCapture: "Capture",
	securityPolTabPrivacy: "Confidentialité et exclusions",
	securityPolTabRetention: "Rétention",
	securityPolTabRules: "Règles",
	securityPolTrackApps: "Suivre les applications actives",
	securityPolTrackFiles: "Suivre l’activité fichiers",
	securityPolTrackWebsites: "Suivre les visites web",
	securityPolTrackingMaster: "Suivi activé (interrupteur maître)",
	securityPolTrackingMasterDesc: "Si désactivé, suivi apps, web, fichiers et saisie inactifs",
	securityPolVisibleNotice: "Afficher un avis de surveillance aux employés",
	securityPolVisibleNoticeDesc: "Affiche une bannière indiquant que la surveillance est active",
	securityPolWorkDayStart: "Début journée de travail (fin hors heures)",
	securityPolWorkingHours: "Heures de travail (facultatif)",
	securityPolWorkingHoursDesc:
		"Capture uniquement sur cette plage. Format HH:MM-HH:MM. Vide = toujours.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"Les badges indiquent ce qui est activé. Pour activer ou désactiver captures d’écran, vidéo, applis, web ou fichiers, ouvrez la politique (crayon) → onglet Capture.",
	securityPoliciesTitle: "Politiques de sécurité",
	securityPolicyDefaultBadge: "Défaut politique",
	securityPriority: "Priorité",
	securityQueued: "En file d’attente !",
	securityRecentOpenAlerts: "Alertes ouvertes récentes",
	securityRecentScreenshots: "Captures récentes",
	securityRecordEverySeconds: "Enregistrer tous les (s)",
	securityRecordVideo30s: "Enregistrer vidéo (30 s)",
	securityRefresh: "Actualiser",
	securityResolution: "Résolution",
	securityResolutionNotePlaceholder: "Note de résolution (facultatif)",
	securityResolve: "Résoudre",
	securityRightClick: "clic droit",
	securityRule: "Règle",
	securityRuleCode_AFTER_HOURS: "Hors heures",
	securityRuleCode_BLOCKED_APP: "App bloquée",
	securityRuleCode_BLOCKED_DOMAIN: "Domaine bloqué",
	securityRuleCode_BULK_FILE_EVENTS: "Événements fichiers en masse",
	securityRuleCode_USB_DETECTED: "USB détecté",
	securitySaveSettings: "Enregistrer",
	securitySaved: "Enregistré",
	securityScope: "Portée",
	securityScopeType_department: "Service",
	securityScopeType_device: "Appareil",
	securityScopeType_global: "Global",
	securityScopeType_user: "Utilisateur",
	securityScreenshotAlt: "Capture",
	securityScreenshotOptionsBlank: "Options capture (vide = défaut politique)",
	securityScreenshots: "Captures",
	securityScreenshotsCount: "Captures",
	securityScreenshotsLabel: "Captures",
	securityScreenshotsToday: "Captures d’écran aujourd’hui",
	securitySearch: "Rechercher",
	securitySearchDevicesPlaceholder: "Rechercher hôte, ID, utilisateur...",
	securitySegmentLengthSeconds: "Durée du segment (s)",
	securitySelectedCount: "sélectionné(s)",
	securitySessionActive: "Actif",
	securitySessionIdle: "Inactif",
	securitySessionLocked: "Écran verrouillé",
	securitySessionLockedCaptureHint: "Écran verrouillé — captures et vue en direct indisponibles.",
	securitySessionLockedLiveHint:
		"L'utilisateur a verrouillé l'écran. La vue en direct, les captures et les enregistrements sont désactivés.",
	securitySessionLockedSince: "Verrouillé depuis",
	securitySessionLockedTitle: "L'écran est verrouillé",
	securitySessionNotFound: "Session introuvable",
	securitySessionTimeline: "Chronologie de session",
	securitySessionWord: "Session",
	securitySessionsTitle: "Sessions",
	securitySettingsDrawerTitle: "Paramètres",
	securitySettingsOverrideHint:
		"Remplacent la politique pour cet appareil seulement. Laissez tel quel pour hériter.",
	securitySev_critical: "critique",
	securitySev_high: "élevée",
	securitySev_low: "faible",
	securitySev_medium: "moyenne",
	securitySeverity: "Gravité",
	securityShowAllVideos: "Afficher toutes les vidéos",
	securitySourceEvents: "Événements sources",
	securitySpeedSec: "Vitesse (s) :",
	securityStart: "Début",
	securityStartLive: "Démarrer le direct",
	securityStatOf: "sur",
	securityStatus: "Statut",
	securityStatus_error: "Erreur",
	securityStatus_offline: "Hors ligne",
	securityStatus_online: "En ligne",
	securityStatus_pending: "En attente",
	securityStatus_unknown: "inconnu",
	securityStopLive: "Arrêter le direct",
	securityTabActivity: "Activité",
	securityTabAlerts: "Alertes",
	securityTabLive: "Direct",
	securityTabScreenshots: "Captures",
	securityTabSessions: "Sessions",
	securityTabSettings: "Paramètres",
	securityTabVideos: "Vidéos",
	securityTakeScreenshot: "Capture d’écran",
	securityTitle: "Titre",
	securityTooltipAppTrack: "Suivi des applications",
	securityTooltipCaptureMaster: "Activer/désactiver capture écran et média (maître)",
	securityTooltipScreenshot: "Activer/désactiver captures",
	securityTooltipTrackingMaster: "Interrupteur maître suivi apps, web, fichiers et saisie",
	securityTooltipWebTrack: "Suivi des domaines",
	securityTopRiskyDevices: "Appareils les plus à risque",
	securityTracking: "Suivi",
	securityTrackingEnabledMaster: "Suivi activé (maître)",
	securityTrackingMasterSwitch: "Suivi activé (maître)",
	securityTrackingOffAlertBody: "Suivi désactivé au niveau appareil, remplace la politique.",
	securityTrackingOffAlertTitle: "Remplacement suivi : OFF",
	securityTrackingWhenOffDesc: "Si désactivé, suivi apps, web, fichiers et saisie inactifs",
	securityUnassigned: "Non assigné",
	securityUnknown: "Inconnu",
	securityUnknownDevice: "Appareil inconnu",
	securityUsePolicyDefault: "Défaut politique",
	securityUser: "Utilisateur",
	securityUserLoggedIn: "Connecté",
	securityVideoOffAlertBody:
		"Vidéo désactivée sur l’appareil. Pas d’enregistrements d’alerte même si la politique les autorise.",
	securityVideoOffAlertTitle: "Remplacement vidéo : OFF",
	securityVideoOptionsBlank: "Options vidéo (vide = politique)",
	securityVideoPlayAllHint:
		"Lire tout du clip sélectionné vers les plus anciens ; à la fin de page, la suivante se charge.",
	securityVideoRecording: "Enregistrement vidéo",
	securityVideoSegments: "Segments vidéo",
	securityVideoSegmentsCount: "Segments vidéo",
	securityViewDetail: "Détails",
	securityWebDomainTracking: "Domaines web",
	securityWebPollSeconds: "Sondage historique web (s)",
	securityWebTracking: "Web",
	securityWebsiteVisitsToday: "Visites web aujourd’hui",
	securityWhen: "Quand",
	selectAlbum: "Sélectionner l'album",
	selectAll: "Tout sélectionner",
	selectArtist: "Sélectionner l'artiste",
	selectBoard: "Sélectionner Board",
	selectCategory: "Sélectionner la catégorie",
	selectChatPartner: "Sélectionnez un partenaire de chat",
	selectClosedDate: "Sélectionnez une date de fermeture",
	selectDate: "Sélectionner la date",
	selectDays: "Sélectionner les jours",
	selectDomain: "Sélectionner le domaine",
	selectEmployee: "Sélectionner un employé",
	selectFiles: "Sélectionner des fichiers",
	selectGroup: "Sélectionner un groupe",
	selectOpenedDate: "Sélectionner la date d'ouverture",
	selectParentDepartment: "Sélectionner le département parent",
	selectParentUser: "Sélectionner l'utilisateur parent",
	selectPeriod: "Sélectionner la période",
	selectPlatformToManageAndNavigate: "Sélectionnez une plateforme pour gérer et naviguer",
	selectPlaylist: "Sélectionner la playlist",
	selectProduct: "Sélectionnez le produit",
	selectSomething: "Sélectionner quelque chose",
	selectUsers: "Sélectionner des utilisateurs",
	selectedSteps: "Étapes sélectionnées",
	selectedUsers: "Utilisateurs sélectionnés",
	seleteSelected: "Sélectionner les sélectionnés",
	send: "Envoyer",
	sent: "Envoyé",
	seoDesc: "Description SEO",
	servicesAndPrices: "Services et tarifs",
	setCostOfBuildingPermit: "Définir le coût du permis de construire",
	setDayOff: "Définir un jour de congé",
	settings: "Paramètres",
	shiftSchedule: "Planning des équipes",
	showAllSteps: "Afficher toutes les étapes",
	showHistory: "Afficher l'historique",
	showProjectDetails: "Afficher les détails du projet",
	showTableColumnFilters: "Afficher les filtres de colonnes",
	showTimeline: "Afficher la chronologie",
	showing: "Affichage",
	shuffle: "Mélanger",
	shuffleEnabled: "Mélange activé",
	shuffleOverride: "Règles de planification",
	shuffleOverrideDesc: "Règles de planification",
	shuffleOverrideValue: "Règles de planification",
	sickLeave: "Congé maladie",
	sickLeaveDays: "Jours de congé maladie",
	signIn: "Se connecter",
	signUp: "S'inscrire",
	size: "Taille",
	slider: "Curseur",
	small: "Petit",
	smb: "Dossier du serveur",
	socialAmount: "Montant de cotisation sociale",
	socialCardImages: "Images de carte sociale",
	socialCart: "Carte sociale",
	socialNetworkLink: "Lien de réseau social",
	socialRate: "Taux de cotisation sociale",
	software: "Logiciel",
	softwareSkills: "Compétences logicielles",
	somethingWentWrong: "Quelque chose s'est mal passé",
	somethingWentWrongInCreatingSteps:
		"Une erreur s'est produite lors de la création des étapes ! Veuillez réessayer",
	sortBy: "Trier par",
	source: "Source",
	special: "Spécial",
	specialItems: "Articles spéciaux",
	speed: "Vitesse",
	starred: "Etoilé",
	starredMessages: "Messages etoiles",
	start: "Commencer",
	startCall: "Démarrer l'appel",
	startDate: "Date de début",
	startDateShort: "Date de début",
	startRecording: "Commencer l'enregistrement",
	startTime: "Heure de début",
	startVideoCall: "Démarrer l'appel vidéo",
	starts: "Commence",
	state: "État",
	states: "États",
	status: "Statut",
	visibility: "Visibilité",
	statusUpdate: "Mise à jour du statut",
	stayAnonymous: "Rester anonyme",
	step: "Étape",
	stepIsNotStartedYet: "L'étape n'a pas encore commencé",
	stepStatus: "État de l'étape",
	stepStatusChangedByUser: "Le statut de l'étape a été modifié par l'utilisateur",
	steps: "Étapes",
	stepsLeft: "Étapes restantes",
	stillInOffice: "Toujours au bureau",
	stockAndProductOverview: "Aperçu des stocks et produits",
	stop: "Arrêter",
	stopRecording: "Arrêter l'enregistrement",
	stopped: "Arrêté",
	streamDJ: "DJ radio",
	streamStatistics: "Statistiques des flux",
	streaming: "Diffusion en continu",
	streamsWithShuffle: "flux avec mélange activé",
	street: "Rue",
	subDesc: "Sous-description",
	submit: "Soumettre",
	submittedProjects: "Projets soumis",
	subscription: "Abonnement",
	subscriptions: "Abonnements",
	substation: "Poste électrique",
	substationNumber: "Numéro de sous-station",
	subtasks: "Tâches secondaires",
	subtasksPlaceholder: "Entrez chaque sous-tâche sur une nouvelle ligne",
	subtitle: "Sous-titre",
	success: "Succès",
	suffix: "Suffixe",
	sun: "Dimanche",
	support: "Support",
	supportText: "Pour toutes questions, écrivez",
	switch: "Commutateur",
	switchers: "Commutateurs",
	switches: "Imprimantes",
	syncedFromGoogleContacts: "Synchronisé depuis Google Contacts",
	systemSettings: "Paramètres du système",
	table: "Table",
	tag: "Étiquette",
	tags: "Tags",
	takeMeHome: "Retour à l'accueil",
	taskCreatedSuccessfully: "Tâche créée avec succès",
	taskCreatedSuccessfullyDescription: "Tâche créée avec succès",
	taskDescription: "Description de la tâche",
	taskMoved: "Tâche déplacée",
	taskMovedDescription: "Tâche déplacée vers une nouvelle catégorie",
	taskStatusDistribution: "Distribution des statuts des tâches",
	taskTitle: "Titre de la tâche",
	tasksAssigned: "Tâches assignées",
	taxCode: "Code fiscal",
	taxNote: "Étiquette",
	taxes: "Impôts",
	technicalFilesUrl: "URL des fichiers techniques",
	telegram: "Télégramme",
	text: "Texte",
	theConstructionDepPrice: "Le prix du département de construction",
	theNumberOfAct: "Le nombre d'actes",
	thePriceOfProject: "Le prix du projet",
	themePickerLabel: "Thème",
	thereIsNoResponsible: "Il n'y a pas de responsable",
	thisMonth: "ce mois",
	thu: "Jeudi",
	ticket: "Ticket",
	ticketClosed: "Ticket fermé",
	ticketCreateSaveDisabledHint:
		"Choisissez le domaine, le groupe de problèmes (si utilisé), le problème, puis remplissez les champs liés obligatoires avant d’enregistrer.",
	ticketDashboard: "Tableau de bord des billets",
	ticketDomain: "Domaine",
	ticketHierarchyAddProblem: "Ajouter un problème",
	ticketHierarchyAddProblemGroup: "Ajouter un groupe",
	ticketHierarchyAddRelatedList: "Ajouter une liste liée",
	ticketHierarchyAddTicket: "Ajouter un ticket",
	ticketHierarchyAddTicketDomain: "Ajouter un domaine",
	ticketHierarchyAddTicketHint: "Ouvre la création de ticket avec ce domaine présélectionné.",
	ticketHierarchyGroupsInDomain: "Groupes de problèmes dans ce domaine",
	ticketHierarchyNoneYet: "Aucun pour l’instant — utilisez le bouton ci-dessus.",
	ticketHierarchyProblemsInGroup: "Problèmes dans ce groupe",
	ticketHierarchyProblemsLinkedToList: "Problèmes utilisant cette liste",
	ticketSystemOverview: "Aperçu des performances et des métriques du système de billets",
	ticketTitle: "Titre",
	ticketType: "Type",
	ticketTypeDomainsHint:
		"Laissez vide pour que ce type soit disponible dans tous les domaines. Sélectionnez un ou plusieurs domaines pour ne l’afficher que là.",
	ticketTypeDomainsListAll: "Tous les domaines",
	ticketStatus_sent: "Envoyé",
	ticketStatus_in_process: "En cours de traitement",
	ticketStatus_resolved_rejected: "Rejeté",
	ticketStatus_resolved_approved: "Approuvé",
	ticketStatus_moved_next: "Transféré à l'étape suivante",
	ticketStatus_moved_prev: "Renvoyé à l'étape précédente",
	ticketStatus_closed: "Fermé",
	ticketStatus_not_accepted: "Non accepté",
	ticketAction_start: "Démarrer le traitement",
	ticketAction_next: "Étape suivante",
	ticketAction_prev: "Étape précédente",
	ticketAction_approve: "Approuver",
	ticketAction_reject: "Rejeter",
	ticketAction_close: "Fermer le billet",
	ticketAction_cancel: "Annuler le ticket",
	ticketAction_comment: "Commentaire",
	cancelTicket: "Annuler le ticket",
	ticketCancelReason: "Motif d'annulation",
	ticketCancelComment: "Commentaire supplémentaire",
	ticketCancelCommentPlaceholder: "Ajoutez des détails pour l'auteur si nécessaire",
	ticketCancelWarning:
		"Ce ticket sera marqué comme non accepté et fermé. Si l'utilisateur a encore besoin d'aide, il devra créer un nouveau ticket.",
	ticketNotAccepted: "Ticket non accepté",
	ticketStepStatus_pending: "En attente",
	ticketStepStatus_active: "Actif",
	ticketStepStatus_completed: "Terminé",
	ticketStepStatus_approved: "Approuvé",
	ticketStepStatus_rejected: "Rejeté",
	ticketStepStatus_closed: "Fermé",
	ticketStepStatus_cancelled: "Annulé",
	tickets: "Billets",
	ticketsByDepartment: "Billets par département",
	ticketsByImportance: "Billets par priorité",
	ticketsByProblem: "Billets par type de problème",
	ticketsByStatus: "Billets par statut",
	ticketsOverTime: "Billets au fil du temps",
	timAgreement: "Accord TIM",
	timDelays: "Retards TIM",
	timSentProjects: "Projets envoyés à TIM",
	time: "Temps",
	timeBasedScheduling: "Planification basée sur le temps",
	timeOff: "Congé",
	timeRange: "Plage horaire",
	timeToClose: "temps pour fermer le billet",
	timeToFirstResponse: "temps jusqu'à la première réponse",
	timeline: "Chronologie",
	timestamp: "Horodatage",
	timezone: "Fuseau horaire",
	title: "Titre",
	to: "À",
	toChat: "Aller au chat",
	toDo: "À faire",
	today: "Aujourd'hui",
	todaysSales: "Ventes d'aujourd'hui",
	todo: "Tâches",
	todoBoard: "Table",
	todoBoards: "Tables",
	todoCategories: "Catégories",
	todoCategory: "Catégorie",
	todoLabel: "Label",
	todoLabels: "Étiquettes",
	todoTag: "Étiquette",
	todoTags: "Tags",
	todoTask: "Tâche",
	todoTasks: "Tâches",
	toggles: "Bascules",
	top: "Meilleur",
	topCustomers: "Meilleurs clients",
	topProducts: "Meilleurs produits",
	total: "Total",
	totalActiveTasks: "Total des tâches actives",
	totalArtists: "Total des artistes",
	totalChats: "Total des chats",
	totalClients: "Total des clients",
	totalCoins: "Total des pièces",
	totalContent: "Contenu total",
	totalCustomers: "Total des clients",
	totalDeductions: "Total des retenues",
	totalDuration: "Durée totale",
	totalGroups: "groupes au total",
	totalHours: "Heures totales",
	missingDays: "Jours manquants",
	missingHours: "Heures manquantes",
	scheduled: "Prévu",
	totalHoursWorked: "Heures de travail totales",
	totalInTrash: "Total dans la corbeille",
	totalMessages: "Total des messages",
	totalOrders: "Total des commandes",
	totalOvertime: "Heures supplémentaires totales",
	totalPlaylists: "Total des playlists",
	totalPrice: "Prix total",
	totalProducts: "Total des produits",
	totalRevenue: "Revenu total",
	totalTickets: "Total des billets",
	totalTracks: "Total des pistes",
	totalUses: "Total d'utilisations",
	totalValue: "Valeur totale",
	track: "Piste",
	trackPlaylist: "Liste de lecture des pistes",
	tracks: "Pistes",
	tracksByArtist: "Pistes par artiste",
	transportAllowance: "Indemnité de transport",
	trash: "Corbeille",
	trashAutoDeleteWarning: "Avertissement de suppression automatique de la corbeille",
	trashEmptied: "La corbeille a été vidée",
	trashedOn: "Supprime le",
	tryAgain: "Réessayer",
	tue: "Mardi",
	type: "Type",
	uncoveredInterval: "Intervalle non couvert",
	undefined: "Indéfini",
	undo: "Annuler",
	university: "Université",
	universityDegree: "Diplôme universitaire",
	universityDepartment: "Département universitaire",
	unjustifiedAbsence: "Absence injustifiée",
	unknown: "Inconnu",
	unknownArtist: "Artiste inconnu",
	unnamed: "Sans nom",
	unnamedClient: "Client sans nom",
	unnamedTrack: "Piste sans nom",
	unpaid: "Non rémunéré",
	unreadMessages: "Messages non lus",
	unresolvedMissingIntervals: "Intervalles manquants non résolus — la paie peut être inexacte",
	upcomingBirthdays: "Anniversaires à venir",
	update: "Mise à jour",
	updatedAt: "Mis à jour à",
	updates: "Mise à jour",
	upload: "Téléverser",
	uploadDate: "Date de téléchargement",
	uploading: "Téléchargement",
	uploads: "Téléchargements",
	uptime: "Temps de fonctionnement",
	urgent: "Urgent",
	used: "Utilisé",
	usedCount: "Nombre d'utilisations",
	usedVacation: "Congés pris",
	user: "Utilisateur",
	userArchive: "Archive utilisateur",
	userDashboard: "Tableau de bord utilisateur",
	userDeleted: "Supprimé",
	userEntered: "L'utilisateur est entré",
	userProfile: "Profil utilisateur",
	userPayrollCalcUsesAttendance:
		"Ce calcul utilise le résumé canonique des présences et congés pour {monthKey}, puis applique les règles fiscales actives des paramètres RH.",
	userUpdated: "Mis à jour",
	userVisited: "L'utilisateur a visité",
	username: "Nom d'utilisateur",
	users: "Ressources humaines",
	vacationBalance: "Solde de congés",
	vacationDaysForPeriod: "Jours de congé pour la période sélectionnée",
	vacationInterval: "Période de congé",
	vacationPay: "Indemnité de congés",
	value: "Valeur",
	version: "Version",
	viber: "Viber",
	video: "Vidéo",
	view: "Voir",
	viewAll: "Afficher tout",
	viewDetails: "Voir les détails",
	viewMore: "Voir plus",
	viewProject: "Voir le projet",
	viewSteps: "Voir les étapes",
	viewTrash: "Afficher la corbeille",
	village: "Village",
	villages: "Liste des villages",
	visitation: "Visite",
	visitationDeadline: "Date limite de visite",
	visitationDelays: "Retards de visite",
	voltage: "Tension",
	voltageLevel: "Niveau de tension",
	volumes: "Volumes",
	voluntaryPensionAmount: "Montant de retraite volontaire",
	voluntaryPensionRate: "Taux de retraite volontaire (%)",
	vsPreviousPeriod: "par rapport à la période précédente",
	warning: "Avertissement",
	warrantyDesc: "Description de garantie",
	warrantyEnd: "Fin de garantie",
	warrantyProvider: "Fournisseur de garantie",
	warrantyStart: "Début de garantie",
	watchers: "Observateurs",
	weatherAriaYerevanForecast: "Prévisions météo pour Erevan",
	weatherCityYerevan: "Erevan",
	weatherClear: "Dégagé",
	weatherCloudy: "Nuageux",
	weatherDrizzle: "Bruine",
	weatherFog: "Brouillard",
	weatherForecastUnavailable: "Prévisions indisponibles",
	weatherHeadingYerevan: "Météo à Erevan",
	weatherHumidity: "Humidité",
	weatherLoadingShort: "Météo",
	weatherNextHours: "Prochaines heures",
	weatherPartlyCloudy: "Partiellement nuageux",
	weatherRain: "Pluie",
	weatherSnow: "Neige",
	weatherThunderstorm: "Orage",
	weatherUnknown: "Prévisions",
	weatherWind: "Vent",
	weatherWindUnit: "km/h",
	wed: "Mercredi",
	weekly: "Hebdomadaire",
	whatToDo: "Que faire",
	whatToDoLink: "Que faire",
	whatsapp: "WhatsApp",
	withAttachments: "Avec pièces jointes",
	withCoins: "Avec des pièces",
	withFavorites: "Avec favoris",
	workDays: "Jours de travail",
	workInformation: "Informations professionnelles",
	workTime: "Temps de travail",
	workedDays: "Jours travaillés",
	workedHours: "Heures travaillées",
	working: "En cours",
	workingDays: "Jours ouvrés",
	workingHoursByDay: "Heures de travail par jour",
	workingMinutes: "Minutes de travail",
	workingState: "Statut de travail",
	workingStatus: "Statut de travail",
	write: "Écrire",
	writeUsIfThereAreAnyQuestions: "Écrivez-nous si vous avez des questions",
	writingContent: "Contenu de l'écriture",
	writingNumber: "Numéro d'écriture",
	yes: "Oui",
	yesNextStep: "Oui, passez à l'étape suivante",
	yesPreviousStep: "Oui, retournez à l'étape précédente",
	youWontBeAbleToRevert: "Vous ne pourrez pas revenir en arrière !",
	yourFileHasBeenDeleted: "Votre fichier a été supprimé.",
	yourFileHasBeenNotSaved: "Votre fichier n'a pas été enregistré.",
	yourFileHasBeenSaved: "Votre fichier a été enregistré.",
	zipCode: "Code postal",
	zipCodes: "Codes postaux",
	vacationIntervalNoDeduction: "Les congés ne sont pas déduits les jours non travaillés",
	knowledgeDashboardLoadFailed: "Échec du chargement du tableau de bord",
	knowledgeArticlesLoadFailed: "Échec du chargement des articles",
	knowledgeBase: "Base de connaissances",
	knowledgeCreate: "Créer",
	knowledgeRunAutoDocs: "Lancer les docs auto",
	knowledgeTotalArticles: "Total des articles",
	knowledgePublished: "Publié",
	knowledgeDrafts: "Brouillons",
	knowledgeAutoGenerated: "Généré automatiquement",
	knowledgeLatestUpdatedArticles: "Derniers articles mis à jour",
	knowledgeArticles: "Articles",
	knowledgeNewArticle: "Nouvel article",
	knowledgeFilterArticles: "Filtrer les articles",
	knowledgeCategories: "Catégories",
	knowledgeParentCategory: "Catégorie parente",
	knowledgeIcon: "Icône",
	knowledgeColor: "Couleur",
	knowledgeSortOrder: "Ordre de tri",
	knowledgeCategorySaved: "Catégorie enregistrée",
	knowledgeCategoryDeleted: "Catégorie supprimée",
	knowledgeSearch: "Recherche",
	knowledgeSearchArticles: "Rechercher des articles",
	knowledgePath: "Chemin",
	knowledgeAutoGeneratedDocs: "Documents générés automatiquement",
	knowledgeSingleRoute: "Route unique",
	knowledgeNoScreenshots: "Aucune capture d’écran",
	knowledgeGenerateDocumentation: "Générer la documentation",
	knowledgeImportGeneratedDocs: "Importer les docs générées",
	knowledgeDocumentationGenerationStarted: "Génération de la documentation démarrée",
	knowledgeImported: "Importé",
	knowledgeGeneratedDocsImported: "{count} documents générés importés",
	knowledgeStarted: "Démarré",
	knowledgeFinished: "Terminé",
	knowledgeRun: "Exécution",
	knowledgeOutput: "Sortie",
	knowledgeStatus_draft: "Brouillon",
	knowledgeStatus_published: "Publié",
	knowledgeStatus_archived: "Archivé",
	knowledgeVisibility_public: "Public",
	knowledgeVisibility_private: "Privé",
	knowledgeVisibility_company: "Entreprise",
	knowledgeRunStatus_idle: "inactif",
	knowledgeRunStatus_running: "en cours",
	knowledgeRunStatus_completed: "terminé",
	knowledgeRunStatus_failed: "échoué",
	meetings: "Réunions",
	meetingsListSubtitle: "Salles planifiées avec chat APIT et calendrier associés.",
	meetingsCreateMeeting: "Créer une réunion",
	meetingsEditMeeting: "Modifier la réunion",
	meetingsCreateSubtitle: "Réunion = événement de calendrier + groupe de chat + salle vidéo.",
	meetingsMeetingType: "Type de réunion",
	meetingsDate: "Date",
	meetingsStartTime: "Heure de début",
	meetingsEndTime: "Heure de fin",
	meetingsTimezone: "Fuseau horaire",
	meetingsVisibility: "Visibilité",
	meetingsParticipants: "Participants",
	meetingsGroupsDepartments: "Groupes/départements",
	meetingsOptionalGroupIds: "ID de groupes facultatifs",
	meetingsLocation: "Lieu",
	meetingsReminderTime: "Heure du rappel",
	meetingsMinutesShort: "min",
	meetingsAgenda: "Ordre du jour",
	meetingsAgendaPlaceholder: "Lancement\nRevue de conception\nProchaines étapes",
	meetingsRecordingEnabled: "Enregistrement activé",
	meetingsAllowJoinBeforeHost: "Autoriser l'arrivée avant l'hôte",
	meetingsMuteUsersOnEntry: "Couper le micro à l'entrée",
	meetingsAllowScreenSharing: "Autoriser le partage d'écran",
	meetingsSaveAsDraft: "Enregistrer comme brouillon",
	meetingsSaveMeeting: "Enregistrer la réunion",
	meetingsCreateAndNotifyUsers: "Créer et notifier les utilisateurs",
	meetingsSaved: "Réunion enregistrée",
	meetingsSaveFailed: "Impossible d'enregistrer la réunion",
	meetingsJoin: "Rejoindre",
	meetingsOpenChat: "Ouvrir le chat",
	meetingsParticipantsCount: "{count} participants",
	meetingsType_video: "Vidéo",
	meetingsType_audio: "Audio",
	meetingsType_in_person: "En présentiel",
	meetingsType_hybrid: "Hybride",
	meetingsVisibility_private: "Privé",
	meetingsVisibility_company: "Entreprise",
	meetingsVisibility_department: "Département",
	meetingsStatus_draft: "Brouillon",
	meetingsStatus_scheduled: "Planifié",
	meetingsStatus_live: "En direct",
	meetingsStatus_ended: "Terminé",
	meetingsStatus_cancelled: "Annulé",
	aiSettingsAction: "Action",
	aiSettingsAllowedModules: "Modules autorisés",
	aiSettingsApprove: "Approuver",
	aiSettingsApprovalFailed: "Approbation échouée",
	aiSettingsDisabled: "Désactivé",
	aiSettingsEnabled: "Activé",
	aiSettingsEvent: "Événement",
	aiSettingsLogs: "Journaux",
	aiSettingsLoadFailed: "Échec du chargement des paramètres d'IA",
	aiSettingsNoGateway: "Passerelle non configurée",
	aiSettingsNoPendingApprovals: "Aucune approbation en attente",
	aiSettingsNoLogs: "Aucun journal",
	aiSettingsNoPermission: "Autorisation d'administrateur IA manquante.",
	aiSettingsPendingApprovals: "Approbations en attente",
	aiSettingsReject: "Rejeter",
	aiSettingsRejectFailed: "Rejet échoué",
	aiSettingsRefresh: "Actualiser",
	aiSettingsRequireApproval: "Approbation requise",
	aiSettingsStatus: "Statut",
	aiSettingsTime: "Heure",
	aiSettingsTitle: "Paramètres IA",
	aiSettingsTool: "Outil",
	aiSettingsUser: "Utilisateur",
	aiSettingsUpdateFailed: "Échec de la mise à jour des paramètres",
	aiSettingsDefaultMode: "Mode par défaut",
	aiSettingsReadOnly: "lecture seule",
	aiSettingsApprovalRequired: "approbation requise",
	aiSettingsAdminOnly: "admin uniquement",
	financeActiveCurrencies: "{count} devises actives",
	financeAddCurrency: "Ajouter une devise",
	financeCurrencyCode: "Code",
	financeCurrencyCoefficient: "Coefficient",
	financeCurrencyDefault: "Par défaut",
	financeCurrencyName: "Nom",
	financeCurrencySymbol: "Symbole",
	financeCurrencyUse: "Utiliser",
	financeLoadFailed: "Échec du chargement des paramètres financiers",
	financeSaveSettings: "Enregistrer les paramètres",
	financeSavedMessage: "Paramètres financiers enregistrés",
	financeSaveFailed: "Échec de l'enregistrement des paramètres financiers",
	financeSelectedDefault: "Sélectionné par défaut:",
	financeSettingsSubtitle:
		"Les devises ici contrôlent l'affichage de la monnaie par défaut dans les pages de finances et de commandes.",
	financeSettingsTitle: "Paramètres financiers",
	hrAccrualCoeffPreview: "Aperçu du coefficient",
	hrAccrualCoeffPreviewLine1:
		"{accrualWorkedHours} heures travaillées → {accrualVacationHours} heures de congés",
	hrAccrualCoeffPreviewLine2: "Heures de congés gagnées par heure travaillée: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"Le serveur stocke cette accumulation en minutes afin que les salaires et les soldes de congés puissent utiliser des valeurs de jours partiels sans biais d'arrondi.",
	hrAccrualFixedYearly: "Jours de vacances annuels fixes",
	hrAccrualFixedYearlyDesc:
		"Accumulez un nombre configuré de jours de vacances tout au long de l'année en utilisant le calendrier quotidien ou mensuel existant.",
	hrAccrualModelChoice:
		"Choisissez un modèle d'accumulation actif. Les jours annuels et le coefficient d'heures travaillées utilisent la logique OR, non combinés.",
	hrAccrualSuffixMin: "min",
	hrAccrualVacationMinutesEarned: "Minutes de congés gagnées",
	hrAccrualVacationMinutesEarnedDesc:
		"Nombre de minutes de congés accumulées par unité de temps de travail.",
	hrAccrualWorkBreak: "Pause de travail",
	hrAccrualWorkBreakDesc:
		"Minutes non couvertes quotidiennement classées comme pauses dans les intervalles d'absence du bureau.",
	hrAccrualWorkedHoursModel: "Heures travaillées en heures de congés",
	hrAccrualWorkedHoursModelDesc:
		"Accumulez les congés à partir du temps de travail réel en utilisant un coefficient d'heures travaillées configurable.",
	hrAccrualWorkedMinutesUnit: "Unité de minutes travaillées",
	hrAccrualWorkedMinutesUnitDesc:
		"Combien de minutes de travail doivent produire une unité d'accumulation.",
	hrWeekdayFri: "Ven",
	hrWeekdayMon: "Lun",
	hrWeekdaySat: "Sam",
	hrWeekdaySun: "Dim",
	hrWeekdayThu: "Jeu",
	hrWeekdayTue: "Mar",
	hrWeekdayWed: "Mer",
	knowledgeSettingsAiEnabled: "IA activée",
	knowledgeSettingsAiModel: "Modèle IA",
	knowledgeSettingsAiProvider: "Fournisseur IA",
	knowledgeSettingsEnableAutoDocs: "Activer la documentation automatique",
	knowledgeSettingsLanguage: "Langue par défaut",
	knowledgeSettingsMaxSizeMb: "Taille maximale de l'article MB",
	knowledgeSettingsRootCategory: "Catégorie racine de la documentation automatique",
	knowledgeSettingsSaveSettings: "Enregistrer les paramètres",
	knowledgeSettingsSaved: "Paramètres de la base de connaissances mis à jour",
	knowledgeSettingsTitle: "Paramètres",
	knowledgeSettingsUploadExt: "Extensions de téléchargement autorisées",
	knowledgeSettingsVisibility: "Visibilité par défaut",
	nvrAddFromList: "Ajouter des caméras à partir de la liste",
	nvrCamerasList: "Liste des caméras",
	nvrChannel: "Canal",
	nvrChannelId: "ID",
	nvrChannelName: "Nom",
	nvrChannelsTitle: "Canaux enregistrés à partir de ce NVR",
	nvrConnectionDesc:
		"Entrez IP, port et modèle de chemin (uniquement /.../{channel}... — comme dans VLC, sans la partie rtsp://). Ajoutez le nom d'utilisateur et le mot de passe RTSP (la plupart des NVR en ont besoin). Cliquez sur Enregistrer pour exécuter une analyse réseau automatique, ou utilisez Ajouter des caméras à partir des chemins ci-dessous pour enregistrer des canaux sans analyse. Ouvrez une caméra pour regarder en direct; sur la carte du bureau, placez les appareils comme d'habitude.",
	nvrConnectionTitle: "NVR — une connexion pour tous les canaux",
	nvrDiscoveryFailed: "La découverte a échoué",
	nvrEnterPaths: "Entrez au moins un canal ou un chemin.",
	nvrFoundChannels: "Trouvé {n} canal(aux).",
	nvrFullUrl: "URL complet (canal 101 — automatique à partir des champs ci-dessus)",
	nvrInitError: "Impossible d'initialiser NVR. Rechargez la page.",
	nvrIp: "IP NVR",
	nvrIpPasswordRequired:
		"IP NVR et mot de passe enregistré requis. Définissez le mot de passe, enregistrez-le, et nous analyserons les canaux lors de la prochaine sauvegarde.",
	nvrLoadFailed: "Échec du chargement du NVR",
	nvrLiveStatus: "Statut en direct",
	nvrManualDesc:
		"Lorsque l'analyse automatique échoue (par exemple, l'API ne peut pas atteindre le NVR), énumérez les canaux ici. Utilisez un par ligne: numéros de canal comme 101, 201, chemin comme /Streaming/Channels/102 ou URL rtsp:// complet. Les chemins sont combinés avec votre modèle de chemin RTSP lorsque vous entrez uniquement des numéros. Enregistrez d'abord le NVR si vous avez modifié IP ou le modèle, puis ajoutez des lignes et cliquez sur le bouton.",
	nvrManualTitle: "Ajouter des caméras à partir des chemins RTSP (pas d'analyse de serveur)",
	nvrNotReady: "NVR non prêt. Rechargez la page.",
	nvrNotReadyShort: "NVR non prêt.",
	nvrNotWorking: "Ne fonctionne pas",
	nvrOfficeMap: "Plan du bureau",
	nvrOffline: "Hors ligne",
	nvrOnline: "En ligne",
	nvrPasswordChangeNote: "Modifiez et enregistrez pour mettre à jour le mot de passe enregistré.",
	nvrPasswordLeaveBlank: "Laissez vide pour conserver le mot de passe actuel",
	nvrPasswordRequired: "Requis pour la plupart des NVR pour découvrir les canaux et la diffusion.",
	nvrPasswordStoredLeaveBlank:
		"Mot de passe enregistré; laissez vide pour le conserver, ou tapez un nouveau.",
	nvrRegisterFailed: "Échec de l'enregistrement des chemins",
	nvrRegisteredCameras: "{n} caméra(s) enregistrée(s).",
	nvrRtspPassword: "Mot de passe RTSP",
	nvrRtspPathTemplate: "Modèle de chemin RTSP",
	nvrRtspPathTemplateHint:
		"Tapez uniquement le chemin avec {channel}. N'entrez pas la chaîne rtsp:// complète ici.",
	nvrRtspUsername: "Nom d'utilisateur RTSP",
	nvrScanChannels: "Analyser les canaux à nouveau",
	nvrScanHint: "Cela enregistre les champs de connexion actuels, puis analyse.",
	nvrWorkingState: "État de travail",
	nvrWorking: "En travail",
	nvrGridEmpty: "Aucun canal lié à ce NVR pour le moment. Exécutez la découverte sur la page NVR.",
	nvrGridLoadFailed: "Échec du chargement des canaux",
	nvrGridLoading: "Chargement des canaux…",
	nvrGridStreamFailed: "Échec du démarrage",
	nvrGridStreamStopped: "Flux arrêté",
	nvrGridTitle: "Tous les canaux NVR",
	securityRecordingActiveDays: "Jours actifs",
	securityRecordingDesc:
		"Activez l'enregistrement côté serveur pour les caméras qui ont l'enregistrement sur serveur activé. Chaque caméra peut également avoir son propre programme ci-dessous.",
	securityRecordingEndTime: "Heure de fin",
	securityRecordingGlobalEnable: "Activer l'enregistrement globalement",
	securityRecordingGlobalEnableDesc:
		"Commutateur principal — désactiver ceci arrête tous les enregistrements indépendamment des paramètres par caméra.",
	securityRecordingLoadFailed: "Échec du chargement des paramètres de sécurité",
	securityRecordingLocalFs: "Système de fichiers local",
	securityRecordingLocalPathNote:
		"Le chemin local est configuré via la variable d'environnement SECURITY_RECORDING_LOCAL_PATH sur le serveur.",
	securityRecordingNoScheduleNote:
		"Pas de calendrier — les caméras enregistreront 24/7 quand l'enregistrement sur serveur est activé.",
	securityRecordingRetentionDays: "Rétention (jours)",
	securityRecordingRetentionDesc:
		"Les segments plus anciens que cela seront supprimés automatiquement.",
	securityRecordingS3: "S3 / stockage d'objets compatible",
	securityRecordingS3Note:
		"Les identifiants S3 sont configurés via les variables d'environnement sur le serveur (AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, etc.).",
	securityRecordingSaveSettings: "Enregistrer les paramètres",
	securityRecordingSaved: "Paramètres de sécurité enregistrés.",
	securityRecordingSaveFailed: "Échec de l'enregistrement des paramètres",
	securityRecordingScheduleDesc:
		"Ce calendrier s'applique à toutes les caméras avec enregistrement sur serveur activé qui n'ont pas leur propre remplacement de calendrier par caméra.",
	securityRecordingScheduleEnable:
		"Activer le calendrier par défaut (enregistrement uniquement pendant les heures définies)",
	securityRecordingScheduleNote:
		"L'enregistrement s'exécutera les jours sélectionnés entre ces heures. En dehors de cette fenêtre, l'enregistrement est automatiquement mis en pause.",
	securityRecordingScheduleTitle: "Calendrier d'enregistrement par défaut",
	securityRecordingSegmentLength: "Longueur du segment (minutes)",
	securityRecordingSegmentLengthDesc:
		"Cela contrôle la fréquence à laquelle une nouvelle vidéo apparaît sur chaque page de caméra.",
	securityRecordingStartTime: "Heure de début",
	securityRecordingStorage: "Stockage",
	securityRecordingStorageBackend: "Backend de stockage",
	securityRecordingTitle: "Enregistrement de caméra sur serveur",
	securitySurveillanceCameraMedia: "Média caméra",
	securitySurveillanceDashboard: "Tableau de bord de surveillance",
	securitySurveillanceNoCameras: "Aucune caméra trouvée.",
	securitySurveillanceOffline: "Hors ligne",
	securitySurveillanceOnline: "En ligne",
	teamWorkload: "Charge de travail de l'équipe",
	workloadTasks: "Tâches",
	workloadTickets: "Tickets",
	workloadSteps: "Étapes",
	assignedEmployee: "Employé assigné",
	boughtDate: "Date d'achat",
	broken: "En panne",
	depreciation: "Dépréciation",
	deviceStatus: "Statut de l'appareil",
	handoverDocument: "Document de remise",
	maintenanceSchedule: "Calendrier de maintenance",
	qrCode: "Code QR",
	repair: "Réparation",
	repairHistory: "Historique des réparations",
	replacementDate: "Date de remplacement",
	retired: "Retiré",
	returnDocument: "Document de retour",
	warrantyDate: "Date de garantie",
	noOpenWorkload: "Aucune charge de travail ouverte",
	attendanceTable: "Tableau des présences",
	filteredFrom: "filtré sur",
	weekend: "Week-end",
	late: "En retard",
	lateDeparture: "Départ tardif",
	employees: "employés",
	exportToExcel: "Exporter vers Excel",
	overtime: "Heures supplémentaires",
	attendanceNextRefresh: "Prochaine actualisation",
	refreshAttendanceDevices: "Actualiser les données des appareils de présence",
	attendanceSyncSuccess: "Appareils de présence synchronisés",
	attendanceSyncFailed: "Échec de la synchronisation des appareils de présence",
	// User account security / profile
	contactInformation: "Informations de contact",
	accountSecurity: "Sécurité du compte",
	accountStatus: "Statut du compte",
	accountStatusActive: "Actif",
	accountStatusLocked: "Verrouillé",
	mustChangePassword: "Doit changer le mot de passe",
	lockedAt: "Verrouillé le",
	passwordLastChanged: "Mot de passe modifié le",
	accountSecurityDesc: "Les mots de passe actuels ne sont jamais visibles. Utilisez un mot de passe temporaire ou un lien de réinitialisation sécurisé lorsque les identifiants doivent changer.",
	accountSecurityHint: "Utilisez « Réinitialiser le mot de passe » pour une rotation immédiate des identifiants. Utilisez « Envoyer le lien de réinitialisation » lorsque l’utilisateur doit choisir un nouveau mot de passe sans que l’admin voie aucun secret.",
	lockAccount: "Verrouiller le compte",
	unlockAccount: "Déverrouiller le compte",
	forcePasswordChangeAction: "Forcer le changement de mot de passe",
	clearForcedPasswordChange: "Annuler le changement forcé",
	resetPassword: "Réinitialiser le mot de passe",
	sendResetLink: "Envoyer le lien de réinitialisation",
	sessionVisibilityRequiresPermission: "La visibilité des sessions et appareils nécessite une permission supplémentaire.",
	resetPasswordConfirmTitle: "Réinitialiser ce mot de passe ?",
	resetPasswordConfirmText: "Un mot de passe temporaire sera généré et l’utilisateur devra le changer à la prochaine connexion.",
	temporaryPasswordGenerated: "Mot de passe temporaire généré",
	temporaryPasswordShareHint: "Partagez-le uniquement via un canal sécurisé.",
	sendResetLinkConfirmTitle: "Envoyer un lien de réinitialisation ?",
	sendResetLinkConfirmText: "Un lien de réinitialisation sécurisé à usage unique sera envoyé par e-mail à cet utilisateur.",
	passwordResetLinkSent: "Lien de réinitialisation envoyé.",
	lockAccountConfirmTitle: "Verrouiller ce compte ?",
	unlockAccountConfirmTitle: "Déverrouiller ce compte ?",
	lockAccountConfirmText: "L’utilisateur ne pourra pas se connecter tant que le compte n’est pas déverrouillé.",
	unlockAccountConfirmText: "L’utilisateur pourra se reconnecter immédiatement.",
	accountLockedMsg: "Compte verrouillé.",
	accountUnlockedMsg: "Compte déverrouillé.",
	forcePasswordChangeConfirmTitle: "Forcer le changement de mot de passe à la prochaine connexion ?",
	removeForcedPasswordChangeConfirmTitle: "Supprimer le changement de mot de passe forcé ?",
	forcePasswordChangeConfirmText: "L’utilisateur ne pourra se connecter que pour changer son mot de passe avant d’utiliser la plateforme.",
	removeForcedPasswordChangeConfirmText: "L’utilisateur pourra continuer à se connecter normalement.",
	forcedPasswordChangeEnabled: "Changement de mot de passe forcé activé.",
	forcedPasswordChangeRemoved: "Changement de mot de passe forcé supprimé.",
	securityUpdated: "Sécurité mise à jour",
	securityActionFailed: "Échec de l’action de sécurité",
	knownDevicesAndSessions: "Appareils connus et sessions ouvertes",
	knownDevicesAndSessionsDesc: "Les emplacements sont approximatifs et représentent généralement une origine IP, un FAI, une sortie VPN ou une passerelle de bureau plutôt que la position physique exacte de l’appareil.",
	openSessionsBadge: "{count} ouvertes",
	revokeOtherSessions: "Révoquer les autres sessions",
	registeredDevices: "Appareils enregistrés",
	unknownDevice: "Appareil inconnu",
	unknownBrowser: "Navigateur inconnu",
	unknownOs: "OS inconnu",
	browserOnOs: "{browser} sur {os}",
	firstSeen: "Vu pour la première fois",
	sessionsBadge: "{count} sessions",
	currentDevice: "Appareil actuel",
	noKnownDevices: "Aucun appareil connu enregistré pour le moment.",
	approximateLoginOrigins: "Origines de connexion approximatives",
	sessionDetails: "Détails des sessions",
	device: "Appareil",
	network: "Réseau",
	lastActive: "Dernière activité",
	approximateLocationUnavailable: "Emplacement approximatif indisponible",
	revoke: "Révoquer",
	noAuthSessions: "Aucune session d’authentification enregistrée pour le moment.",
	sessionOriginApproximateNote: "Les données d’origine de session sont approximatives. Ne considérez pas la géolocalisation IP comme la position exacte de l’appareil.",
	connectedMeansNote: "« Connecté » signifie que le navigateur/l’application a encore un socket actif. « Déconnecté » signifie que le navigateur a été fermé ou est hors ligne, mais la session enregistrée peut rester valide jusqu’à déconnexion, révocation ou expiration.",
	revokeThisSessionTitle: "Révoquer cette session ?",
	revokeThisSessionText: "L’appareil/session sélectionné devra se reconnecter.",
	revokeSession: "Révoquer la session",
	sessionRevoked: "Session révoquée",
	sessionRevokedSuccess: "La session sélectionnée a été révoquée avec succès.",
	failedToRevokeSession: "Échec de la révocation de la session",
	unableToRevokeSession: "Impossible de révoquer la session sélectionnée.",
	revokeOtherSessionsTitle: "Révoquer les autres sessions ?",
	revokeOtherSessionsText: "Toutes les sessions de cet utilisateur seront révoquées sauf la session actuelle lorsque l’utilisateur révoque ses propres appareils.",
	revokeSessions: "Révoquer les sessions",
	sessionsRevoked: "Sessions révoquées",
	revokedSessionsCount: "{count} sessions révoquées.",
	failedToRevokeSessions: "Échec de la révocation des sessions",
	unableToRevokeSessions: "Impossible de révoquer les sessions sélectionnées.",
	failedToLoadSessions: "Échec du chargement des sessions",
	unableToLoadUserSessions: "Impossible de charger les sessions utilisateur.",
	sessionStatusRevoked: "Révoquée",
	sessionStatusConnected: "Connecté",
	sessionStatusDisconnected: "Déconnecté",
	currentSession: "Actuelle",
	passwordChangeOnly: "Changement de mot de passe uniquement",
	faceId: "Face ID",
	passwordsNeverShownHint: "Les mots de passe ne sont jamais affichés ici. Utilisez l’onglet Sécurité pour verrouiller ou déverrouiller ce compte, forcer un changement de mot de passe, générer un mot de passe temporaire ou envoyer un lien de réinitialisation.",
	sharedFolders: "Dossiers partagés",
	flexId: "Flex Id",
	emailNotProvided: "E-mail non fourni",
	anonymousUser: "Utilisateur anonyme",
	noMapPointsYet: "Aucun point sur la carte pour le moment",
	noMapPointsYetDesc: "Aucun emplacement de session avec des coordonnées approximatives n’est encore disponible. Le backend peut toujours suivre les appareils et sessions sans fournisseur géo.",
	googleMapsKeyNotConfigured: "Clé Google Maps non configurée",
	googleMapsKeyNotConfiguredDesc: "Définissez REACT_APP_GOOGLE_MAPS_API_KEY pour afficher la carte des sessions approximatives.",
	mapFailedToLoad: "Échec du chargement de la carte",
	mapFailedToLoadDesc: "Impossible de charger Google Maps pour le moment.",
	approximateLocation: "Emplacement approximatif",
	attendanceLastRefreshed: "Dernière actualisation",
	quarter: "Trimestre",
	year: "Année",
	currentQuarter: "Trimestre en cours",
	currentYear: "Année en cours",
	chatClearHistory: "Effacer l'historique",
	chatClearHistoryConfirm: "Effacer l'historique de cette discussion uniquement pour vous ?",
	chatDeleteForMe: "Supprimer la discussion",
	chatDeleteForMeConfirm: "Supprimer cette discussion uniquement pour vous ? Votre historique visible sera effacé et la discussion disparaîtra de votre barre latérale.",
	chatBlockUser: "Bloquer l'utilisateur",
	chatUnblockUser: "Débloquer l'utilisateur",
	chatBlockedSection: "Contacts bloqués",
	chatBlockUserConfirm: "Bloquer cet utilisateur ? Il ne pourra plus vous écrire dans cette discussion.",
};
